/*
@license
  Be Yours by roartheme (https://roartheme.co)
  Access unminified JS in assets/global.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://roartheme.co/blogs/beyours/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/
window.theme = window.theme || {};

theme.config = {
  mqlSmall: false,
  mediaQuerySmall: "screen and (max-width: 749px)",
  isTouch:
    "ontouchstart" in window ||
      (window.DocumentTouch && window.document instanceof DocumentTouch) ||
      window.navigator.maxTouchPoints ||
      window.navigator.msMaxTouchPoints
      ? true
      : false,
  rtl: document.documentElement.getAttribute("dir") === "rtl" ? true : false,
};


theme.Currency = (function () {
  const moneyFormat = "${{amount}}"; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString =
      format || theme.shopSettings.moneyFormat || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split(".");
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      const centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function getBaseUnit(variant) {
    if (!variant) {
      return;
    }

    if (
      !variant.unit_price_measurement ||
      !variant.unit_price_measurement.reference_value
    ) {
      return;
    }

    return variant.unit_price_measurement.reference_value === 1
      ? variant.unit_price_measurement.reference_unit
      : variant.unit_price_measurement.reference_value +
      variant.unit_price_measurement.reference_unit;
  }

  return {
    formatMoney: formatMoney,
    getBaseUnit: getBaseUnit,
  };
})();

/* -------------------------------------------------------------------------
 * ATC button price for single-button product pages (e.g. Lean-to)
 * Same rules as l-pre-order-product-form: GPO option price from
 * .gpo-label .addOn → .gpo-tooltip .addOn → priceSelectors in optionContainer.
 * ------------------------------------------------------------------------- */
(function () {
  var PRICE_REGEX = /[\d,]+\.?\d*/;
  var PRICE_SELECTORS = [
    ".gpo-option-price",
    ".price",
    "[data-price]",
    ".gpo-price",
    ".option-price",
    ".variant-price",
    'span[class*="price"]',
    'div[class*="price"]',
    ".addOn",
  ];

  function getOptionPriceFromContainer(optionContainer) {
    var label = optionContainer.querySelector(".gpo-label .addOn");
    if (label) {
      var priceMatch = label.textContent.trim().match(PRICE_REGEX);
      if (priceMatch) return parseFloat(priceMatch[0].replace(/,/g, ""));
    }
    var tooltip = optionContainer.querySelector(".gpo-tooltip .addOn");
    if (tooltip) {
      var priceMatch = tooltip.textContent.trim().match(PRICE_REGEX);
      if (priceMatch) return parseFloat(priceMatch[0].replace(/,/g, ""));
    }
    for (var i = 0; i < PRICE_SELECTORS.length; i++) {
      var el = optionContainer.querySelector(PRICE_SELECTORS[i]);
      if (el) {
        var priceMatch = el.textContent.trim().match(PRICE_REGEX);
        if (priceMatch) return parseFloat(priceMatch[0].replace(/,/g, ""));
      }
    }
    return 0;
  }

  theme.getGpoOptionsTotal = function (currentVariantId) {
    var optionsTotal = 0;
    var selectedOptions = document.querySelectorAll(
      '.gpo-element input[type="radio"]:checked, .gpo-swatches input[type="radio"]:checked'
    );
    var variantIdStr = currentVariantId != null ? String(currentVariantId) : null;
    var seen = new Set();

    for (var i = 0; i < selectedOptions.length; i++) {
      var option = selectedOptions[i];
      if (seen.has(option)) continue;
      seen.add(option);
      var optionVariantId = option.getAttribute("gpo-data-variant-id");
      if (variantIdStr && optionVariantId === variantIdStr) continue;

      var optionItem = option.closest(".gpo-ov-item");
      var optionGroup = option.closest(".gpo-element");
      var optionContainer = optionItem || optionGroup || option.closest(".gpo-swatches");
      if (!optionContainer) continue;

      var optionPrice = getOptionPriceFromContainer(optionContainer);
      if (optionPrice === 0 && optionGroup && optionGroup !== optionContainer) {
        optionPrice = getOptionPriceFromContainer(optionGroup);
      }
      if (optionPrice > 0) optionsTotal += optionPrice;
    }
    return optionsTotal;
  };

  var mainButtonTitleSelector = ".l-product-preorder-button__title, .l-flex, .l-flex-col";
  theme.mainButtonTitleSelector = mainButtonTitleSelector;

  function getVisibleMainButton() {
    var container = document.querySelector(".product-form");
    if (!container) return null;
    var clone = container.querySelector(".gpo-clone-atc-button:not(.l-hidden)");
    if (clone && clone.querySelector(mainButtonTitleSelector)) return clone;
    var visible = container.querySelectorAll(".product-form__submit:not(.l-hidden), .l-buy-option-inner-button[type='submit']:not(.l-hidden)");
    for (var i = 0; i < visible.length; i++) {
      if (visible[i].querySelector(mainButtonTitleSelector)) return visible[i];
    }
    return container.querySelector(".product-form__submit");
  }

  theme.updateMainButtonVariantPrice = function (variant, buttonEl) {
    if (!variant || !theme.Currency || !theme.Currency.formatMoney) return;

    var basePrice = variant.price / 100;
    var optionsTotal = theme.getGpoOptionsTotal(variant.id);
    var totalPrice = basePrice + optionsTotal;
    var formattedPrice = theme.Currency.formatMoney(totalPrice * 100);

    var buttons = [];
    if (buttonEl && buttonEl.querySelector(mainButtonTitleSelector)) buttons.push(buttonEl);
    document.querySelectorAll(".product-form .product-form__submit, .product-form .gpo-clone-atc-button, .product-form .l-buy-option-inner-button[type='submit']").forEach(function (btn) {
      if (buttons.indexOf(btn) === -1 && btn.querySelector(mainButtonTitleSelector)) buttons.push(btn);
    });

    buttons.forEach(function (btn) {
      var title = btn.querySelector(mainButtonTitleSelector);
      if (!title) return;

      var strongs = title.querySelectorAll("strong");
      for (var i = 0; i < strongs.length; i++) {
        var text = strongs[i].textContent.trim();
        if (
          (text.indexOf("$") !== -1 || /\d/.test(text)) &&
          text.indexOf("pre-order") === -1 &&
          text.indexOf("save") === -1 &&
          text.indexOf("%") === -1 &&
          !strongs[i].hasAttribute("data-amount")
        ) {
          strongs[i].textContent = formattedPrice;
        }
      }

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var comparePrice = variant.compare_at_price / 100;
        var formattedCompare = theme.Currency.formatMoney(comparePrice * 100);
        var sEls = title.querySelectorAll("s");
        for (var j = 0; j < sEls.length; j++) {
          if (/\d/.test(sEls[j].textContent)) {
            sEls[j].textContent = formattedCompare;
            sEls[j].style.display = "inline";
          }
        }
        var reduction = comparePrice - basePrice;
        var pct = Math.round((reduction / comparePrice) * 100);
        var formattedAmount = theme.Currency.formatMoney(reduction * 100);
        for (var k = 0; k < strongs.length; k++) {
          var t = strongs[k].textContent.trim();
          if (t.indexOf("save") !== -1 && t.indexOf("%") !== -1) {
            var innerAmount = strongs[k].querySelector("[data-amount]");
            if (innerAmount) {
              innerAmount.textContent = formattedAmount;
              strongs[k].childNodes.forEach(function(node) {
                if (node.nodeType === 3 && node.textContent.indexOf("save") !== -1) {
                  node.textContent = "(save " + pct + "%) ";
                }
              });
            } else {
              strongs[k].textContent = "(save " + pct + "%)";
            }
            strongs[k].style.display = "inline";
          }
        }
        // Update amount elements outside strong
        var amountEls = title.querySelectorAll("[data-amount]");
        for (var a = 0; a < amountEls.length; a++) {
          amountEls[a].textContent = formattedAmount;
          amountEls[a].style.display = "inline";
        }
      } else {
        var sElsHide = title.querySelectorAll("s");
        for (var h = 0; h < sElsHide.length; h++) sElsHide[h].style.display = "none";
        for (var m = 0; m < strongs.length; m++) {
          var t2 = strongs[m].textContent.trim();
          if (t2.indexOf("save") !== -1 && t2.indexOf("%") !== -1) strongs[m].style.display = "none";
        }
        // Hide amount when no discount
        var amountElsHide = title.querySelectorAll("[data-amount]");
        for (var n = 0; n < amountElsHide.length; n++) amountElsHide[n].style.display = "none";
      }
    });
  };

  var cachedMainVariant = null;
  var lastVariantChangeTime = 0;

  document.addEventListener("variant:change", function (e) {
    if (e.detail && e.detail.variant) {
      cachedMainVariant = e.detail.variant;
      lastVariantChangeTime = Date.now();
    }
    scheduleUpdate();
    setTimeout(scheduleUpdate, 300);
    setTimeout(scheduleUpdate, 600);
  });

  document.addEventListener("productInfo:loaded", function () {
    scheduleUpdate();
  });

  document.addEventListener("change", function (e) {
    if (e.target && e.target.name === "id" && e.target.closest && e.target.closest('form[data-type="add-to-cart-form"]')) {
      var form = e.target.closest("form");
      var section = form && form.closest("section");
      var picker = section && (section.querySelector("variant-selects") || section.querySelector("variant-radios"));
      var variantId = e.target.value;
      var variant = picker && picker.currentVariant;
      if (picker && picker.getVariantData && variantId && (!variant || String(variant.id) !== String(variantId))) {
        var data = picker.getVariantData();
        variant = data && data.find(function (v) { return String(v.id) === String(variantId); });
      }
      if (variant) {
        cachedMainVariant = variant;
        lastVariantChangeTime = Date.now();
      }
      scheduleUpdate();
      setTimeout(scheduleUpdate, 100);
      setTimeout(scheduleUpdate, 400);
    }
  }, true);

  function restorePicker(cached) {
    if (!cached) return;
    var picker = document.querySelector("variant-selects") || document.querySelector("variant-radios");
    if (!picker || (picker.currentVariant && picker.currentVariant.id === cached.id)) return;

    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    var input = form && form.querySelector('input[name="id"]');
    if (input && input.value === String(cached.id)) return;

    if (input) input.value = String(cached.id);

    var sel = picker.querySelector("select");
    if (sel && sel.value !== String(cached.id)) {
      sel.value = String(cached.id);
      return;
    }

    if (picker.getVariantData && picker.tagName === "VARIANT-RADIOS") {
      var variants = picker.getVariantData();
      var v = variants && variants.find(function (x) { return x.id === cached.id; });
      if (!v) return;
      ["option1", "option2", "option3"].forEach(function (key) {
        if (v[key] == null) return;
        var group = picker.querySelector('.variant-input-wrapper[data-option-index="' + key + '"]');
        if (!group) return;
        var val = String(v[key]);
        var radios = group.querySelectorAll('input[type="radio"]');
        for (var r = 0; r < radios.length; r++) {
          if ((radios[r].value === val || radios[r].getAttribute("data-option-value") === val) && !radios[r].checked) {
            radios[r].checked = true;
            break;
          }
        }
      });
    }
  }

  function getPickerForButton(btn) {
    if (!btn) return null;
    var section = btn.closest("section");
    if (!section) return null;
    return section.querySelector("variant-selects") || section.querySelector("variant-radios");
  }

  function runUpdate() {
    if (!theme.updateMainButtonVariantPrice) return;
    var btn = getVisibleMainButton();
    if (!btn || !btn.querySelector(mainButtonTitleSelector)) return;
    var section = btn.closest("section");
    var picker = getPickerForButton(btn) || document.querySelector("variant-selects") || document.querySelector("variant-radios");
    var variant = picker && picker.currentVariant;
    var recentlyChanged = Date.now() - lastVariantChangeTime < 700;

    if (recentlyChanged && cachedMainVariant) {
      variant = cachedMainVariant;
    } else if (cachedMainVariant && (!variant || variant.id !== cachedMainVariant.id)) {
      restorePicker(cachedMainVariant);
      variant = cachedMainVariant;
    } else if (variant) {
      cachedMainVariant = variant;
    }

    var form = btn.closest("form") || document.querySelector('form[data-type="add-to-cart-form"]');
    var idInput = form && form.querySelector('input[name="id"]');
    var variantIdFromInput = idInput && idInput.value;
    if (picker && picker.getVariantData && variantIdFromInput && (!variant || String(variant.id) !== String(variantIdFromInput))) {
      var data = picker.getVariantData();
      variant = data && data.find(function (v) { return String(v.id) === String(variantIdFromInput); });
      if (variant) cachedMainVariant = variant;
    }

    if (variant) {
      theme.updateMainButtonVariantPrice(variant, btn);
      if (variant.available !== false) {
        document.querySelectorAll(".product-form .product-form__submit, .product-form .gpo-clone-atc-button, .product-form .l-buy-option-inner-button[type='submit']").forEach(function (b) {
          if (b.querySelector(mainButtonTitleSelector)) b.removeAttribute("disabled");
        });
      }
    }
  }

  function scheduleUpdate() {
    runUpdate();
    setTimeout(runUpdate, 150);
  }

  document.addEventListener("gpo:variant:changed", scheduleUpdate);
  document.addEventListener("click", function (e) {
    if (e.target && e.target.closest && (e.target.closest(".gpo-swatches") || e.target.closest(".gpo-element")))
      scheduleUpdate();
  }, true);

  var scheduled;
  var observed = new Set();
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === "attributes" && (m.attributeName === "data-gpo-selected" || m.attributeName === "checked")) {
        if (scheduled) clearTimeout(scheduled);
        scheduled = setTimeout(scheduleUpdate, 50);
        break;
      }
    }
  });
  function observeGpo() {
    document.querySelectorAll("[data-gpo-selected], input[type='radio'][gpo-data-variant-id]").forEach(function (el) {
      if (observed.has(el)) return;
      observed.add(el);
      try { observer.observe(el, { attributes: true, attributeFilter: ["data-gpo-selected", "checked"] }); } catch (err) {}
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      observeGpo();
      setTimeout(scheduleUpdate, 350);
    });
  } else {
    observeGpo();
    setTimeout(scheduleUpdate, 350);
  }
  document.addEventListener("gpo:options:initialized", function () {
    setTimeout(observeGpo, 200);
    setTimeout(scheduleUpdate, 250);
  });
  document.addEventListener("gpo:app:loaded", function () {
    setTimeout(scheduleUpdate, 400);
  });
})();

theme.initWhenVisible = function (options) {
  const threshold = options.threshold ? options.threshold : 0;

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (typeof options.callback === "function") {
            options.callback();
            observer.unobserve(entry.target);
          }
        }
      });
    },
    { rootMargin: `0px 0px ${threshold}px 0px` }
  );

  observer.observe(options.element);
};

(function () {
  // Trigger events when going between breakpoints
  const mql = window.matchMedia(theme.config.mediaQuerySmall);
  theme.config.mqlSmall = mql.matches;
  mql.onchange = (e) => {
    if (e.matches) {
      theme.config.mqlSmall = true;
      document.dispatchEvent(new CustomEvent("matchSmall"));
    } else {
      theme.config.mqlSmall = false;
      document.dispatchEvent(new CustomEvent("unmatchSmall"));
    }
  };

  // Page transition
  window.addEventListener("beforeunload", () => {
    document.body.classList.add("unloading");
  });
  window.addEventListener("DOMContentLoaded", () => {
    document.body.classList.add("loaded");

    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
  window.addEventListener("pageshow", (event) => {
    // Removes unload class when returning to page via history
    if (event.persisted) {
      document.body.classList.remove("unloading");
    }
  });

  // Viewport height
  function viewportHeight() {
    if (window.matchMedia("(max-width: 990px)")) {
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    }

    setHeaderBottomPosition();
  }
  window.addEventListener("resize", debounce(viewportHeight, 200));
  window.addEventListener("DOMContentLoaded", viewportHeight);

  if (document.body.getAttribute("data-page-rendering") !== null) {
    // Improve initial load time by skipping the rendering of offscreen content
    const observer = new IntersectionObserver(
      (entries, _observer) => {
        entries.forEach((entry) => {
          const el = entry.target;
          // Not currently in intersection area.
          if (entry.intersectionRatio == 0) {
            return;
          }
          // Trigger rendering for elements within scroll area that haven't already been marked.
          if (!el.markedVisible) {
            el.attributeStyleMap &&
              el.attributeStyleMap.set("content-visibility", "visible");
            el.markedVisible = true;
          }
        });
      },
      // Set a rendering 100px above and 500px below the main scroll area.
      // Larger bottom margin prevents CLS on mobile (sections render before entering viewport).
      { rootMargin: "100px 0px 500px 0px" }
    );
    const sections = document.querySelectorAll(
      ".shopify-section + .shopify-section"
    );
    sections.forEach((section) => {
      observer.observe(section);
    });
  }


})();

// Prevent vertical scroll while using flickity sliders
(function () {
  var e = !1;
  var t;

  document.body.addEventListener("touchstart", function (i) {
    if (!i.target.closest(".flickity-slider")) {
      return (e = !1);
    }
    e = !0;
    t = {
      x: i.touches[0].pageX,
      y: i.touches[0].pageY,
    };
  });

  document.body.addEventListener(
    "touchmove",
    function (i) {
      if (e && i.cancelable) {
        var n = {
          x: i.touches[0].pageX - t.x,
          y: i.touches[0].pageY - t.y,
        };
        if (
          window.Flickity &&
          Flickity.defaults &&
          Math.abs(n.x) > Flickity.defaults.dragThreshold
        ) {
          i.preventDefault();
        }
      }
    },
    { passive: !1 }
  );
})();

function isStorageSupported(type) {
  // Return false if we are in an iframe without access to sessionStorage
  if (window.self !== window.top) {
    return false;
  }

  const testKey = "beyours:test";
  let storage;
  if (type === "session") {
    storage = window.sessionStorage;
  }
  if (type === "local") {
    storage = window.localStorage;
  }

  try {
    storage.setItem(testKey, "1");
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    // Do nothing, this may happen in Safari in incognito mode
    return false;
  }
}

function checkScrollbar() {
  const rect = document.body.getBoundingClientRect();
  return Math.round(rect.left + rect.right) < window.innerWidth;
}

function setScrollbarWidth() {
  if (checkScrollbar()) {
    const element = document.createElement("span");
    (element.className = "modal-scrollbar-measure"),
      document.body.appendChild(element);

    const width = element.getBoundingClientRect().width - element.clientWidth;
    document.body.removeChild(element);
    document.documentElement.style.setProperty(
      "--scrollbar-width",
      `${width}px`
    );
  }
}

function setHeaderBottomPosition() {
  const header = document.querySelector(".shopify-section-header");
  if (header) {
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(header.getBoundingClientRect().bottom)}px`
    );
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    const charCode = event.code
      ? event.code.toUpperCase()
      : event.key.toUpperCase();
    if (charCode !== "TAB") return; // If not TAB key

    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  if (elementToFocus) elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll("iframe.js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll("iframe.js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document
    .querySelectorAll(
      'video-section[data-type="youtube"]:not([data-video-hero]) iframe'
    )
    .forEach((video) => {
      video.contentWindow.postMessage(
        '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
        "*"
      );
    });
  document
    .querySelectorAll(
      'video-section[data-type="vimeo"]:not([data-video-hero]) iframe'
    )
    .forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', "*");
    });
  document.querySelectorAll("video").forEach((video) => {
    if (!video.closest("[data-video-hero]")) video.pause();
  });
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  const charCode = event.code
    ? event.code.toUpperCase()
    : event.key.toUpperCase();
  if (charCode !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

function filterShopifyEvent(event, domElement, callback) {
  let executeCallback = false;
  if (event.type.includes("shopify:section")) {
    if (
      domElement.hasAttribute("data-section-id") &&
      domElement.getAttribute("data-section-id") === event.detail.sectionId
    ) {
      executeCallback = true;
    }
  } else if (
    event.type.includes("shopify:block") &&
    event.target === domElement
  ) {
    executeCallback = true;
  }
  if (executeCallback) {
    callback(event);
  }
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  const method = options["method"] || "post";
  const params = options["parameters"] || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.postLink2 = function (path, options) {
  options = options || {};
  const method = options["method"] || "post";
  const params = options["parameters"] || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    for (const index in params[key]) {
      for (const key2 in params[key][index]) {
        const hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", `${key}[${index}][${key2}]`);
        hiddenField.setAttribute("value", params[key][index][key2]);
        form.appendChild(hiddenField);
      }
    }
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class QuantityInput extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );

    this.input.addEventListener("focus", this.onInputFocus.bind(this));
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  onInputFocus() {
    this.input.select();
  }
}
customElements.define("quantity-input", QuantityInput);

class DrawerCloseButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", () =>
      this.dispatchEvent(
        new CustomEvent("drawer:force-close", {
          bubbles: true,
          cancelable: true,
          composed: true,
        })
      )
    );
  }
}
customElements.define("drawer-close-button", DrawerCloseButton);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      open: "menu-drawer--open",
      opening: "menu-drawer--opening",
      closing: "menu-drawer--closing",
    };

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  setClasses(classes) {
    this.classes = classes;
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button[data-close]").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );

    this.addEventListener("drawer:force-close", (event) => {
      event.stopPropagation();
      this.closeMenuDrawer(event);
    });
  }

  onKeyUp(event) {
    const charCode = event.code
      ? event.code.toUpperCase()
      : event.key.toUpperCase();
    if (charCode !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
        event,
        this.mainDetailsToggle.querySelector("summary")
      )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else if (detailsElement.hasAttribute("data-accordion")) {
      // Accordion behavior: let native <details> handle toggle
      summaryElement.setAttribute("aria-expanded", !isOpen);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
            "transitionend",
            addTrapFocus
          );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement = false) {
    setScrollbarWidth();
    setHeaderBottomPosition();

    if (summaryElement) {
      summaryElement.setAttribute("aria-expanded", true);
      trapFocus(this.mainDetailsToggle, summaryElement);
    }

    setTimeout(() => {
      this.onBodyClickEvent =
        this.onBodyClickEvent || this.onBodyClick.bind(this);
      document.body.addEventListener("click", this.onBodyClickEvent);
    });
    document.body.classList.add(this.classes.opening);

    this.openAnimation();
    setTimeout(() => {
      this.mainDetailsToggle.setAttribute("open", "");
      setTimeout(() => {
        this.mainDetailsToggle.classList.add("menu-opening");
      }, 10);
    });
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
        // Reset accordion aria-expanded
        const summary = details.querySelector("summary");
        if (summary) summary.setAttribute("aria-expanded", false);
      });
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.classList.add("menu-closing");
      removeTrapFocus(elementToFocus);

      document.body.removeEventListener("click", this.onBodyClickEvent);
      document.body.classList.remove(this.classes.open);
      document.body.classList.add(this.classes.closing);

      this.closeAnimation(this.mainDetailsToggle);
      this.dispatchEvent(new CustomEvent("close"));
      document.dispatchEvent(new CustomEvent("menudrawer:close"));
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const target = event.currentTarget;
    if (target.classList.contains("noclose")) return;

    const detailsElement = target.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  openAnimation() {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        document.body.classList.remove(this.classes.opening);
        document.body.classList.add(this.classes.open);
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        if (detailsElement === this.mainDetailsToggle) {
          document.body.classList.remove(this.classes.closing);
          detailsElement.classList.remove("menu-closing");
        }
        detailsElement.removeAttribute("open");

        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }

  onBodyClick(event) {
    if (!this.contains(event.target)) this.closeMenuDrawer(event);
  }
}
customElements.define("menu-drawer", MenuDrawer);

class CartDrawer extends MenuDrawer {
  constructor() {
    super();

    this.setClasses({
      open: "mini-cart--open",
      opening: "mini-cart--opening",
      closing: "mini-cart--closing",
    });
  }
}
customElements.define("cart-drawer", CartDrawer);

class FacetDrawer extends MenuDrawer {
  constructor() {
    super();

    if (this.dataset.desktop == "true") {
      this.setClasses({
        open: "facet-horizontal--open",
        opening: "facet-horizontal--opening",
        closing: "facet-horizontal--closing",
      });
    } else {
      this.setClasses({
        open: "facet-drawer--open",
        opening: "facet-drawer--opening",
        closing: "facet-drawer--closing",
      });
    }
  }
}
customElements.define("facet-drawer", FacetDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    this.setClasses({
      open: "menu-mobile--open",
      opening: "menu-mobile--opening",
      closing: "menu-mobile--closing",
    });
  }
}
customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      const charCode = event.code
        ? event.code.toUpperCase()
        : event.key.toUpperCase();
      if (charCode === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  show(opener) {
    setScrollbarWidth();
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector("button");
    if (!this.button) return;

    this.button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(this.button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();

    this.poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!this.poster) return;

    this.poster.addEventListener("click", (e) => {
      console.log('[DeferredMedia] click on poster', this.poster.id, 'has data-custom-gallery-open:', this.poster.hasAttribute('data-custom-gallery-open'));
      if (this.poster.hasAttribute('data-custom-gallery-open')) return;
      this.loadContent();
    });
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      if (content.querySelector("video-section")) {
        const deferredElement = this.appendChild(content);
        if (focus) deferredElement.focus();
        if (
          deferredElement.nodeName == "VIDEO" &&
          deferredElement.getAttribute("autoplay")
        ) {
          // force autoplay for safari
          deferredElement.play();
        }
      } else {
        this.setAttribute("loaded", true);
        const deferredElement = this.appendChild(
          content.querySelector("video, model-viewer, iframe")
        );
        if (focus) deferredElement.focus();
        if (
          deferredElement.nodeName == "VIDEO" &&
          deferredElement.getAttribute("autoplay")
        ) {
          // force autoplay for safari
          deferredElement.play();
        }
      }
    }
  }
}
customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200,
    });
  }

  init() {
    const resizeObserver = new ResizeObserver(() => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.currentPage === 1 && this.currentPage === this.totalPages) {
      this.classList.add("slider--no-buttons");
    } else {
      this.classList.remove("slider--no-buttons");
    }

    if (this.enableSliderLooping) return;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (isFirstSlide || this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      isLastSlide ||
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();

    let step = event.currentTarget.dataset.step || 1;

    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    //this.slideScrollPosition = theme.config.rtl ? this.slideScrollPosition * -1 : this.slideScrollPosition;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class ThumbnailSlider extends SliderComponent {
  constructor() {
    super();
  }

  init() {
    super.init();

    const variantItems = this.querySelectorAll(
      ".thumbnail-list_item--variant:not(.is-active)"
    );
    this.slider.dataset.mediaCount =
      this.sliderItems.length - variantItems.length;

    if (this.querySelector("[data-gang-option]")) {
      const inactiveGangItems = this.querySelectorAll(
        "[data-gang-option]:not(.gang__active)"
      );
      this.slider.dataset.mediaCount =
        this.sliderItems.length - inactiveGangItems.length;
    }

    if (this.slider.dataset.mediaCount < 2) this.classList.add("hidden");
  }
}
customElements.define("thumbnail-slider", ThumbnailSlider);

class QuoteSlider extends SliderComponent {
  constructor() {
    super();
  }

  update() {
    super.update();

    if (this.currentPageElement && this.pageTotalElement) {
      this.sliderItems.forEach((element) => {
        element.removeAttribute("aria-current");
      });

      const currentElement = this.sliderItemsToShow[this.currentPage - 1];
      currentElement.setAttribute("aria-current", true);
    }
  }
}
customElements.define("quote-slider", QuoteSlider);

class ProductGallery extends SliderComponent {
  constructor() {
    super();
  }

  init() {
    super.init();

    this.mediaGalleryEl = this.closest("media-gallery");

    const gallerySliderButtons = this.querySelector(".slider-buttons");
    if (gallerySliderButtons && this.querySelector("[data-gang-option]")) {
      if (
        this.querySelectorAll(".product__media-item.gang__active").length < 2
      ) {
        gallerySliderButtons.classList.add("hidden");
      } else {
        gallerySliderButtons.classList.remove("hidden");
      }
    }

    this.cursor = this.querySelector(".gallery-cursor");
    if (!this.cursor) return;

    const images = this.querySelectorAll(".product__modal-opener--image");
    images.forEach((image) =>
      image.addEventListener("mousemove", this.onMoveHandler.bind(this))
    );
    images.forEach((image) =>
      image.addEventListener("mouseenter", this.onEnterHandler.bind(this))
    );
    images.forEach((image) =>
      image.addEventListener("mouseleave", this.onLeaveHandler.bind(this))
    );
  }

  onMoveHandler(event) {
    this.cursor.style.left = `${event.clientX - 32}px`;
    this.cursor.style.top = `${event.clientY - 32}px`;
  }

  onEnterHandler() {
    this.cursor.classList.add("show");
  }

  onLeaveHandler() {
    this.cursor.classList.remove("show");
  }

  update() {
    super.update();

    if (this.currentPageElement && this.pageTotalElement) {
      const currentElement = this.sliderItemsToShow[this.currentPage - 1];
      if (currentElement) {
        this.slider.style.setProperty(
          "--force-image-ratio-percent",
          currentElement
            .querySelector(".media")
            .style.getPropertyValue("--image-ratio-percent")
        );
      }
    }
  }

  onButtonClick(event) {
    event.preventDefault();

    const mainProduct = document.getElementById('mainProduct');
    const thumbEls = mainProduct
      ? mainProduct.querySelectorAll('.product-gallery-thumb[data-target]')
      : [];

    if (thumbEls.length === 0 || window.innerWidth < 750) {
      let step = event.currentTarget.dataset.step || 1;
      this.slideScrollPosition =
        event.currentTarget.name === "next"
          ? this.slider.scrollLeft + step * this.sliderItemOffset
          : this.slider.scrollLeft - step * this.sliderItemOffset;
      this.slider.scrollTo({
        left: this.slideScrollPosition,
        behavior: 'smooth'
      });
      return;
    }

    let activeThumb = null;
    thumbEls.forEach((t) => {
      if (t.classList.contains('is-active')) activeThumb = t;
    });

    if (!activeThumb) {
      let step = event.currentTarget.dataset.step || 1;
      this.slideScrollPosition =
        event.currentTarget.name === "next"
          ? this.slider.scrollLeft + step * this.sliderItemOffset
          : this.slider.scrollLeft - step * this.sliderItemOffset;
      this.slider.scrollTo({
        left: this.slideScrollPosition,
        behavior: 'smooth'
      });
      return;
    }

    let currentIndex = -1;
    thumbEls.forEach((t, i) => {
      if (t === activeThumb) currentIndex = i;
    });

    const isNext = event.currentTarget.name === "next";
    const total = thumbEls.length;

    let nextIndex;
    if (isNext) {
      if (currentIndex >= total - 1) return;
      nextIndex = currentIndex + 1;
    } else {
      if (currentIndex <= 0) return;
      nextIndex = currentIndex - 1;
    }

    const nextThumb = thumbEls[nextIndex];
    if (!nextThumb) return;

    const targetMediaId = nextThumb.dataset.target;
    if (this.mediaGalleryEl && this.mediaGalleryEl.navigateInstant) {
      this.mediaGalleryEl.navigateInstant(targetMediaId);
    } else {
      this.mediaGalleryEl.setActiveMedia(targetMediaId, false, true);
    }
  }

  goToFirstSlide() {
    this.slider.scrollTo({
      left: 0,
    });
  }
}
customElements.define("product-gallery", ProductGallery);

class VariantSelects extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("change", this.onVariantChange);

    this.updateOptions();
    this.updateMasterId();
    this.setAvailability();
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.validateGang();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
      this.setAvailabilityInUnavailable();
    } else {
      if (this.gangOption) {
        this.updateGangMedia();
      } else {
        this.updateMedia();
      }
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.setAvailability();

      document.dispatchEvent(
        new CustomEvent("variant:change", {
          detail: {
            variant: this.currentVariant,
          },
        })
      );
    }

    this.handleStickyCart(event.target);
  }

  handleStickyCart(target) {
    const stickyCart = document.getElementById(
      `sticky-cart-${this.dataset.section}`
    );
    if (!stickyCart) return;

    const attribute = target.getAttribute("name");

    document
      .querySelectorAll(
        `variant-radios[data-section="${this.dataset.section}"] [name="${attribute}"], variant-selects[data-section="${this.dataset.section}"] [name="${attribute}"]`
      )
      .forEach((input) => {
        if (input.tagName === "INPUT") {
          input.checked = input.value === target.value;
        } else {
          input.value = target.value;
        }
      });

    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const image = document.querySelector(".sticky-cart__content-image img");
    if (image) {
      image.srcset = `${this.currentVariant.featured_media.preview_image.src}&width=70 1x, ${this.currentVariant.featured_media.preview_image.src}&width=140 2x`;
      image.src = `${this.currentVariant.featured_media.preview_image.src}&width=70`;
      image.width = 70;
      image.height = Math.ceil(
        70 / this.currentVariant.featured_media.preview_image.aspect_ratio
      );
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    const variantData = this.getVariantData();
    if (!variantData) return;

    // Try to find exact match
    this.currentVariant = variantData.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    // If exact match not found or not available, auto-select closest available variant
    if (!this.currentVariant || !this.currentVariant.available) {
      const fallbackVariant = this.findClosestAvailableVariant(variantData);

      if (fallbackVariant) {
        this.currentVariant = fallbackVariant;
        // Update selects to match the auto-selected variant
        this.updateSelectsToVariant(fallbackVariant);
      }
    }
  }

  findClosestAvailableVariant(variantData) {
    // First, try to find available variants matching as many options as possible
    const availableVariants = variantData.filter(v => v.available);

    if (!availableVariants.length) return null;

    // Try to match option1, then option2, then option3
    for (let i = 0; i < this.options.length; i++) {
      const matchingVariants = availableVariants.filter(variant => {
        for (let j = 0; j <= i; j++) {
          if (variant.options[j] !== this.options[j]) return false;
        }
        return true;
      });

      if (matchingVariants.length > 0) {
        return matchingVariants[0];
      }
    }

    // If no partial match, return first available variant
    return availableVariants[0];
  }

  updateSelectsToVariant(variant) {
    const selects = this.querySelectorAll('select');
    selects.forEach((select, index) => {
      if (variant.options[index]) {
        select.value = variant.options[index];
      }
    });

    // Update the options array to match
    this.updateOptions();
  }

  validateGang() {
    const mediaItemWithGang = document.querySelector(
      `#shopify-section-${this.dataset.section} [data-gang-option], quick-view-drawer details[open] [data-gang-option]`
    );
    if (mediaItemWithGang) {
      this.gangOption = mediaItemWithGang.dataset.gangOption;
    }
  }

  updateGangMedia() {
    if (!this.gangOption) return;

    const variantInputWrapper = this.querySelector(
      '.variant-input-wrapper[data-option-slug="' + this.gangOption + '"]'
    );
    if (variantInputWrapper) {
      this.gangIndex = variantInputWrapper.dataset.optionIndex;
    } else {
      this.gangOption = null;
    }

    if (!this.currentVariant) return;
    //if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`
    );
    const gangValue = this.getSlug(this.currentVariant[this.gangIndex]);
    if (this.currentGangValue !== gangValue) {
      document
        .querySelectorAll(
          `#shopify-section-${this.dataset.section} [data-gang-connect], quick-view-drawer details[open] [data-gang-connect]`
        )
        .forEach(function (media) {
          media.classList.remove("gang__active");
        });

      this.currentGangValue = gangValue;
      var gangConnect = this.gangOption + "_" + gangValue;
      const newMedias = document.querySelectorAll(
        `#shopify-section-${this.dataset.section} [data-gang-connect="${gangConnect}"], quick-view-drawer details[open] [data-gang-connect="${gangConnect}"]`
      );

      if (!newMedias.length) return;
      Array.from(newMedias)
        .reverse()
        .forEach(function (newMedia) {
          newMedia.classList.add("gang__active");
          let parent = newMedia.parentElement;
          if (parent.firstChild != newMedia) {
            parent.prepend(newMedia);
            parent.classList.add("product__media-no-animate");
          }
        });

      const thumbnailSlider = document.getElementById(
        `GalleryThumbnails-${this.dataset.section}`
      );
      if (thumbnailSlider) {
        const allThumbs = thumbnailSlider.querySelectorAll(
          ".product-gallery-thumb, .thumbnail-list__item"
        );
        const inactiveItems = thumbnailSlider.querySelectorAll(
          ".product-gallery-thumb:not(.gang__active), .thumbnail-list__item:not(.gang__active)"
        );
        const activeCount = allThumbs.length - inactiveItems.length;
        const track = thumbnailSlider.querySelector("[data-media-count]");
        if (track) track.dataset.mediaCount = activeCount;
        if (thumbnailSlider.slider) {
          thumbnailSlider.slider.dataset.mediaCount = activeCount;
        }
        if (activeCount < 2) {
          thumbnailSlider.classList.add("hidden");
        } else {
          thumbnailSlider.classList.remove("hidden");
        }
        if (thumbnailSlider.resetPages) thumbnailSlider.resetPages();
      }

      if (!mediaGallery) {
        const productGallery = document.querySelector(
          `#shopify-section-${this.dataset.section} product-gallery, quick-view-drawer details[open] product-gallery`
        );
        if (productGallery) {
          productGallery.resetPages();
          productGallery.goToFirstSlide();
        }
      }

      const gallerySliderButtons = document.querySelector(
        `#shopify-section-${this.dataset.section} product-gallery .slider-buttons, quick-view-drawer details[open] product-gallery .slider-buttons`
      );
      if (gallerySliderButtons) {
        if (
          document.querySelectorAll(
            `#shopify-section-${this.dataset.section} product-gallery .product__media-item.gang__active, quick-view-drawer details[open] product-gallery .product__media-item.gang__active`
          ).length < 2
        ) {
          gallerySliderButtons.classList.add("hidden");
        } else {
          gallerySliderButtons.classList.remove("hidden");
        }
      }
    }

    if (!this.currentVariant.featured_media) {
      if (
        !document.querySelectorAll(
          `#shopify-section-${this.dataset.section} product-gallery .product__media-item.gang__active.is-active, quick-view-drawer details[open] product-gallery .product__media-item.gang__active.is-active`
        ).length
      ) {
        document
          .querySelector(
            `#shopify-section-${this.dataset.section} product-gallery .product__media-item.gang__active, quick-view-drawer details[open] product-gallery .product__media-item.gang__active`
          )
          .classList.add("is-active");
      }
      return;
    }

    if (mediaGallery) {
      const scrollIntoView = typeof this.dataset.noScroll === "undefined";
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true,
        scrollIntoView
      );
    }

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (modalContent) {
      const newMediaModal = modalContent.querySelector(
        `[data-media-id="${this.currentVariant.featured_media.id}"]`
      );
      modalContent.prepend(newMediaModal);
    }

    const thumbnailContent = document.querySelector(
      `#ProductThumbnails-${this.dataset.section}`
    );
    if (thumbnailContent) {
      const newMediaThumbnail = thumbnailContent.querySelector(
        `[data-media-id="${this.currentVariant.featured_media.id}"]`
      );
      thumbnailContent.prepend(newMediaThumbnail);
    }
  }

  CJKDetect(someString) {
    // Korean
    if (someString.search("[\uac00-\ud7a3]") >= 0) return "ko";
    // Japanese
    if (someString.search("[\u3040-\u30ff]") >= 0) return "ja";
    // Chinese
    if (someString.search("[\u4e00-\u9FFF]") >= 0) return "zh";

    return "none";
  }

  getSlug(someString) {
    if (this.CJKDetect(someString) != "none") return someString;
    return someString
      .toString()
      .replace("ı", "i")
      .normalize("NFD")
      .replace("-", " ")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9 ]/g, "")
      .replace(/\s+/g, "-");
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;

    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    parent.prepend(newMedia);
    parent.classList.add("product__media-no-animate");
    parent.parentElement.goToFirstSlide();

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`
    );
    if (mediaGallery) {
      const scrollIntoView = typeof this.dataset.noScroll === "undefined";
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true,
        scrollIntoView
      );
    }

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (modalContent) {
      const newMediaModal = modalContent.querySelector(
        `[data-media-id="${this.currentVariant.featured_media.id}"]`
      );
      modalContent.prepend(newMediaModal);
    }

    const thumbnailContent = document.querySelector(
      `#ProductThumbnails-${this.dataset.section}`
    );
    if (thumbnailContent) {
      const newMediaThumbnail = thumbnailContent.querySelector(
        `[data-media-id="${this.currentVariant.featured_media.id}"]`
      );
      thumbnailContent.prepend(newMediaThumbnail);
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-${this.dataset.section}--alt`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        this.updateSKU(responseText);
        this.updatePrice(responseText);
        this.updatePriceAlt(responseText);
        this.updateColorName(responseText);
        this.updateInventoryStatus(responseText);
        if (this.currentVariant)
          this.toggleAddButton(
            !this.currentVariant.available,
            theme.variantStrings.soldOut
          );
        this.updateCustomLiquid(responseText);

        document.dispatchEvent(new CustomEvent("productInfo:loaded"));

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            responseText,
            variant: this.currentVariant,
          },
        });
      })
      .catch((e) => {
        console.error(e);
      });
  }

  updateSKU(responseText) {
    const id = `sku-${this.dataset.section}`;
    const html = new DOMParser().parseFromString(responseText, "text/html");
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove("visibility-hidden");
  }

  updateCustomLiquid(responseText) {
    const html = new DOMParser().parseFromString(responseText, "text/html");
    const destinations = document.querySelectorAll(
      `.custom__liquid-${this.dataset.section}`
    );
    const sources = html.querySelectorAll(
      `.custom__liquid-${this.dataset.section}`
    );

    for (let i = 0, clLength = destinations.length; i < clLength; i++) {
      destinations[i].innerHTML = sources[i].innerHTML;
    }
  }

  updatePrice(responseText) {
    const id = `price-${this.dataset.section}`;
    const html = new DOMParser().parseFromString(responseText, "text/html");
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove("visibility-hidden");
  }

  updatePriceAlt(responseText) {
    const id = `price-${this.dataset.section}--alt`;
    const html = new DOMParser().parseFromString(responseText, "text/html");
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove("visibility-hidden");
  }

  updateColorName(responseText) {
    const html = new DOMParser().parseFromString(responseText, "text/html");

    for (let index = 1; index <= 3; index++) {
      const id =
        index > 1
          ? `color-${this.dataset.section}-${index}`
          : `color-${this.dataset.section}`;
      const destination = document.getElementById(id);
      const source = html.getElementById(id);

      if (source && destination) destination.innerHTML = source.innerHTML;
      if (destination) destination.classList.remove("visibility-hidden");
    }
  }

  updateInventoryStatus(responseText) {
    const id = `inventory-${this.dataset.section}`;
    const html = new DOMParser().parseFromString(responseText, "text/html");
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
    if (destination) destination.classList.remove("visibility-hidden");

    // Re-initialize simulated/fixed stock after innerHTML swap (scripts don't execute via innerHTML)
    if (destination) {
      const simulatedItem = destination.querySelector('.product__inventory-item--simulated');
      if (simulatedItem) {
        const mode = simulatedItem.dataset.mode;
        let fakeStock;
        if (mode === 'fixed') {
          fakeStock = parseInt(simulatedItem.dataset.fixedQty, 10) || 3;
        } else {
          const variantId = simulatedItem.dataset.variantId;
          const today = new Date().toISOString().split('T')[0];
          const str = today + '-' + variantId;
          let hash = 0;
          for (let i = 0; i < str.length; i++) {
            hash = ((hash << 5) - hash) + str.charCodeAt(i);
            hash |= 0;
          }
          fakeStock = (Math.abs(hash) % 12) + 1;
        }
        const countEl = destination.querySelector('.js-simulated-stock-count');
        if (countEl) countEl.textContent = fakeStock;
        const bar = destination.querySelector('progress-bar[data-simulated]');
        if (bar) bar.setAttribute('data-quantity', fakeStock);
      }
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-${this.dataset.section}--alt`
    );
    productForms.forEach((productForm) => {
      const addButton =
        productForm.querySelector('.gpo-clone-atc-button[name="add"]') ||
        productForm.querySelector('[name="add"]:not(.l-hidden)') ||
        productForm.querySelector('[name="add"]');
      if (!addButton) return;
      const addButtonText =
        addButton.querySelector("[data-atc-label]") || addButton;

      if (disable) {
        addButton.setAttribute("disabled", true);
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute("disabled");

        const mainTitleSel = theme.mainButtonTitleSelector || ".l-product-preorder-button__title, .l-flex, .l-flex-col";
        const hasCustomContent = addButton.querySelector(mainTitleSel) ||
          addButton.querySelector('.l-product-preorder-button__estimate') ||
          (addButton.innerHTML.trim() !== addButton.textContent.trim() &&
            addButton.innerHTML.includes('<') &&
            addButton.innerHTML.includes('>'));

        if (!hasCustomContent) {
          addButtonText.textContent =
            addButton.dataset.preOrder === "true"
              ? theme.variantStrings.preOrder
              : theme.variantStrings.addToCart;
        } else {
          if (this.currentVariant && theme.updateMainButtonVariantPrice) {
            theme.updateMainButtonVariantPrice(this.currentVariant, addButton);
          }
        }
      }

      if (!modifyClass) return;
    });
  }

  setUnavailable() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-${this.dataset.section}--alt`
    );
    productForms.forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]');
      if (!addButton) return;

      const mainTitleSel = theme.mainButtonTitleSelector || ".l-product-preorder-button__title, .l-flex, .l-flex-col";
      const hasCustomContent = addButton.querySelector(mainTitleSel) ||
        addButton.querySelector('.l-product-preorder-button__estimate') ||
        (addButton.innerHTML.trim() !== addButton.textContent.trim() &&
          addButton.innerHTML.includes('<') &&
          addButton.innerHTML.includes('>'));

      if (!hasCustomContent) {
        addButton.textContent = theme.variantStrings.unavailable;
      } else {
      }

      const price = document.getElementById(`price-${this.dataset.section}`);
      if (price) price.classList.add("visibility-hidden");

      const priceAlt = document.getElementById(
        `price-${this.dataset.section}--alt`
      );
      if (priceAlt) priceAlt.classList.add("visibility-hidden");

      const inventory = document.getElementById(
        `inventory-${this.dataset.section}`
      );
      if (inventory) inventory.classList.add("visibility-hidden");
    });
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]')?.textContent ||
                 document.querySelector('[data-variant-json]')?.textContent || '[]');
    return this.variantData;
  }

  setAvailability() {
    if (!this.currentVariant) return;

    this.querySelectorAll(".variant-input-wrapper").forEach((group) => {
      this.disableVariantGroup(group);
    });

    const currentlySelectedValues = this.currentVariant.options.map(
      (value, index) => {
        return { value, index: `option${index + 1}` };
      }
    );
    const initialOptions = this.createAvailableOptionsTree(
      this.variantData,
      currentlySelectedValues,
      this.currentVariant
    );

    for (var [option, values] of Object.entries(initialOptions)) {
      this.manageOptionState(option, values);
    }
  }

  setAvailabilityInUnavailable() {
    this.querySelectorAll(".variant-input-wrapper").forEach((group) => {
      this.disableVariantGroup(group);
    });

    const currentlySelectedValues = this.options.map((value, index) => {
      return { value, index: `option${index + 1}` };
    });
    const initialOptions = this.createAvailableOptionsTree(
      this.variantData,
      currentlySelectedValues,
      this.currentVariant
    );

    for (var [option, values] of Object.entries(initialOptions)) {
      this.manageOptionState(option, values);
    }
  }

  enableVariantOption(group, obj) {
    const value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1");
    group.querySelector('option[value="' + value + '"]').disabled = false;
  }

  disableVariantGroup(group) {
    group.querySelectorAll("option").forEach((option) => {
      option.disabled = true;
    });
  }

  manageOptionState(option, values) {
    const group = this.querySelector(
      '.variant-input-wrapper[data-option-index="' + option + '"]'
    );

    // Loop through each option value
    values.forEach((obj) => {
      this.enableVariantOption(group, obj);
    });
  }

  createAvailableOptionsTree(variants, currentlySelectedValues) {
    // Reduce variant array into option availability tree
    return variants.reduce(
      (options, variant) => {
        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach((index) => {
          if (variant[index] === null) return;

          let entry = options[index].find(
            (option) => option.value === variant[index]
          );

          if (typeof entry === "undefined") {
            // If option has yet to be added to the options tree, add it
            entry = { value: variant[index], soldOut: true };
            options[index].push(entry);
          }

          const currentOption1 = currentlySelectedValues.find(
            ({ value, index }) => index === "option1"
          );
          const currentOption2 = currentlySelectedValues.find(
            ({ value, index }) => index === "option2"
          );

          switch (index) {
            case "option1":
              // Option1 inputs should always remain enabled based on all available variants
              entry.soldOut =
                entry.soldOut && variant.available ? false : entry.soldOut;
              break;
            case "option2":
              // Option2 inputs should remain enabled based on available variants that match first option group
              if (
                currentOption1 &&
                variant["option1"] === currentOption1.value
              ) {
                entry.soldOut =
                  entry.soldOut && variant.available ? false : entry.soldOut;
              }
            case "option3":
              // Option 3 inputs should remain enabled based on available variants that match first and second option group
              if (
                currentOption1 &&
                variant["option1"] === currentOption1.value &&
                currentOption2 &&
                variant["option2"] === currentOption2.value
              ) {
                entry.soldOut =
                  entry.soldOut && variant.available ? false : entry.soldOut;
              }
          }
        });

        return options;
      },
      { option1: [], option2: [], option3: [] }
    );
  }
}
customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }

  enableVariantOption(group, obj) {
    const value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1");
    const input = group.querySelector(
      'input[data-option-value="' + value + '"]'
    );

    // Variant exists - enable & show variant
    input.removeAttribute("disabled");
    input.removeAttribute("data-crossout");

    // Variant sold out - cross out option (remains selectable)
    if (obj.soldOut) {
      if (this.hasAttribute("data-swatch-cross")) {
        if (this.hasAttribute("data-swatch-oos-click")) {
          input.setAttribute("data-crossout", "");
        } else {
          input.setAttribute("disabled", "");
        }
      }
    }
  }

  disableVariantGroup(group) {
    group.querySelectorAll("input").forEach((input) => {
      input.setAttribute("disabled", "");
    });
  }

  updateSelectsToVariant(variant) {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    fieldsets.forEach((fieldset, index) => {
      if (variant.options[index]) {
        const radios = fieldset.querySelectorAll("input");
        radios.forEach((radio) => {
          if (radio.value === variant.options[index]) {
            radio.checked = true;
          }
        });
      }
    });

    // Update the options array to match
    this.updateOptions();
  }
}
customElements.define("variant-radios", VariantRadios);

class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.miniCart = document.querySelector("mini-cart");
    this.form = this.querySelector("form");
    this.form.querySelector("[name=id]").disabled = false;
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.hideErrors = this.dataset.hideErrors === "true";
  }

  onSubmitHandler(evt) {
    if (
      document.body.classList.contains("template-cart") ||
      !theme.shopSettings.cartDrawer
    ) {
      return;
    }

    evt.preventDefault();

    const cloneButton = this.querySelector(".gpo-clone-atc-button:not(.l-hidden)");
    const originalButton = this.querySelector(
      ".gpo-original-atc-button:not(.l-hidden), [type='submit']:not(.gpo-clone-atc-button):not(.l-hidden)"
    );
    const clickedSubmitter =
      evt.submitter &&
      evt.submitter.matches &&
      evt.submitter.matches('[type="submit"]')
        ? evt.submitter
        : null;

    if (clickedSubmitter && clickedSubmitter.hasAttribute('data-pre-order-button')) {
      return;
    }

    const submitButton =
      clickedSubmitter || cloneButton || originalButton || this.querySelector('[type="submit"]');

    if (!submitButton) {
      return;
    }

    if (submitButton.classList.contains("loading")) {
      return;
    }

    if (cloneButton && originalButton && cloneButton !== originalButton) {
      originalButton.setAttribute("aria-disabled", true);
      originalButton.classList.add("loading");
    }

    const directCheckout = this.dataset.directCheckout === "true";

    this.handleErrorMessage();

    submitButton.setAttribute("aria-disabled", true);
    submitButton.classList.add("loading");

    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];

    const formData = new FormData(this.form);

    const additionalProducts = [];
    document
      .querySelectorAll('input[type="radio"]:checked[gpo-data-variant-id]')
      .forEach((radio) => {
        const variantId = radio.getAttribute("gpo-data-variant-id");
        if (variantId) {
          const productId = parseInt(variantId);
          if (!isNaN(productId) && productId > 0) {
            additionalProducts.push({
              id: productId,
              quantity: 1,
            });
          }
        }
      });

    if (additionalProducts.length > 0) {
      const mainVariantId = formData.get("id");
      const mainQuantity = formData.get("quantity") || 1;

      const properties = {};
      for (let [key, value] of formData.entries()) {
        if (key.startsWith("properties[")) {
          const propertyName = key
            .replace("properties[", "")
            .replace("]", "");
          properties[propertyName] = value;
        }
      }

      const items = [
        ...additionalProducts,
        {
          id: parseInt(mainVariantId),
          quantity: parseInt(mainQuantity),
          properties: Object.keys(properties).length > 0 ? properties : undefined,
        },
      ];

      const payload = {
        items: items,
      };

      if (this.miniCart && !directCheckout) {
        payload.sections = this.miniCart
          .getSectionsToRender()
          .map((section) => section.id);
      }
      payload.sections_url = window.location.pathname;

      config.body = JSON.stringify(payload);
      config.headers["Content-Type"] = "application/json";

      fetch(`${theme.routes.cart_add_url}.js`, config)
        .then((response) => {
          if (!response.ok) {
            return response.text().then((text) => {
              throw new Error(`HTTP ${response.status}: ${text}`);
            });
          }
          return response.json();
        })
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: "product-form",
              productVariantId: mainVariantId,
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);
            this.error = true;
            return;
          }

          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "product-form",
              productVariantId: mainVariantId,
            });
          this.error = false;

          if (directCheckout) {
            window.location.href = "/checkout";
            return;
          }

          const miniCart = this.miniCart || document.querySelector("mini-cart");
          if (miniCart) {
            miniCart.renderContents(response);
            if (miniCart.open) {
              miniCart.open();
            }
          }
        })
        .catch((e) => {
          console.error(e);
          this.handleErrorMessage(`Erro ao adicionar produto: ${e.message}`);
        })
        .finally(() => {
          submitButton.classList.remove("loading");
          submitButton.removeAttribute("aria-disabled");

          const originalButton = this.querySelector(".gpo-original-atc-button");
          if (originalButton && originalButton !== submitButton) {
            originalButton.classList.remove("loading");
            originalButton.removeAttribute("aria-disabled");
          }
        });

      return;
    }

    if (this.miniCart && !directCheckout) {
      formData.append(
        "sections",
        this.miniCart.getSectionsToRender().map((section) => section.id)
      );
    }
    formData.append("sections_url", window.location.pathname);
    config.body = formData;

    fetch(`${theme.routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: "product-form",
            productVariantId: formData.get("id"),
            errors: response.errors || response.description,
            message: response.message,
          });
          this.handleErrorMessage(response.description);
          this.error = true;
          return;
        }

        if (!this.error)
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: formData.get("id"),
          });
        this.error = false;

        if (directCheckout) {
          window.location.href = "/checkout";
          return;
        }

        const miniCart = this.miniCart || document.querySelector("mini-cart");
        if (miniCart) {
          miniCart.renderContents(response);
          if (miniCart.open) {
            miniCart.open();
          }
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove("loading");
        submitButton.removeAttribute("aria-disabled");

        const originalButton = this.querySelector(".gpo-original-atc-button");
        if (originalButton && originalButton !== submitButton) {
          originalButton.classList.remove("loading");
          originalButton.removeAttribute("aria-disabled");
        }
      });
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper =
      this.errorMessageWrapper ||
      this.querySelector(".product-form__error-message-wrapper");

    if (this.errorMessageWrapper) {
      if (this.hideErrors) return;
      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper.querySelector(".product-form__error-message");
      this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    } else {
      if (errorMessage) {
        alert(errorMessage);
      }
    }
  }
}
customElements.define("product-form", ProductForm);

document.addEventListener("DOMContentLoaded", function () {
  function addButtonFix() {
    const atcButtons = document.querySelectorAll(".gpo-clone-atc-button");

    atcButtons.forEach((button) => {
      if (button.dataset.fixApplied) return;
      button.dataset.fixApplied = "true";

      button.addEventListener(
        "click",
        function (e) {
          e.preventDefault();
          e.stopPropagation();

          if (button.classList.contains("loading")) {
            return;
          }

          const productForm = button.closest("product-form");
          if (productForm) {
            const form = productForm.querySelector("form");
            if (form) {
              setTimeout(() => {
                const submitEvent = new Event("submit", {
                  bubbles: true,
                  cancelable: true,
                });
                form.dispatchEvent(submitEvent);
              }, 50);
            }
          } else {
            const form = button.closest("form");
            if (form) {
              const variantInput = form.querySelector('input[name="id"]');
              const variantId = variantInput ? variantInput.value : null;

              if (variantId && theme.shopSettings.cartDrawer) {
                button.setAttribute("aria-disabled", true);
                button.classList.add("loading");

                const miniCart = document.querySelector("mini-cart");
                const sections = miniCart
                  ? miniCart.getSectionsToRender().map((section) => section.id)
                  : [];

                const formData = new FormData(form);
                formData.append("sections", sections);
                formData.append("sections_url", window.location.pathname);

                const config = fetchConfig("javascript");
                config.headers["X-Requested-With"] = "XMLHttpRequest";
                delete config.headers["Content-Type"];
                config.body = formData;

                fetch(`${theme.routes.cart_add_url}`, config)
                  .then((response) => response.json())
                  .then((response) => {
                    if (response.status) {
                      console.error("Error adding to cart:", response.description);
                      return;
                    }

                    if (miniCart) {
                      miniCart.renderContents(response);
                      if (miniCart.open) {
                        miniCart.open();
                      }
                    }
                  })
                  .catch((e) => {
                    console.error("Error:", e);
                  })
                  .finally(() => {
                    button.classList.remove("loading");
                    button.removeAttribute("aria-disabled");
                  });
              }
            }
          }
        },
        true
      );
    });
  }

  addButtonFix();

  setTimeout(addButtonFix, 1000);
  setTimeout(addButtonFix, 3000);

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            if (
              node.classList &&
              node.classList.contains("gpo-clone-atc-button")
            ) {
              addButtonFix();
            }
            const newButtons =
              node.querySelectorAll &&
              node.querySelectorAll(".gpo-clone-atc-button");
            if (newButtons && newButtons.length) {
              addButtonFix();
            }
          }
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

class ProgressBar extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 0,
    });
  }

  init() {
    setTimeout(() => {
      const quantity = parseInt(this.dataset.quantity);
      this.style.setProperty(
        "--progress-bar-width",
        `${(quantity * 100) / 30}%`
      );
    }, 1e3);
  }
}
customElements.define("progress-bar", ProgressBar);

class FormState extends HTMLElement {
  constructor() {
    super();

    this.formInputs = this.querySelectorAll("input,select,textarea");
    this.form = this.querySelector("form");

    this.formInputs.forEach((input) => {
      input.addEventListener("input", this.onInputChange.bind(this));
      input.addEventListener("blur", this.onInputChange.bind(this));
    });

    if (this.form)
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
  }

  onInputChange(event) {
    this.handleInputCheck(event.target);
  }

  onSubmitHandler(event) {
    let valid = !0;

    this.formInputs.forEach((input) => {
      if (!this.handleInputCheck(input)) {
        valid = !1;
      }
    });

    if (!valid) {
      event.preventDefault();
      return;
    }
  }

  handleInputCheck(input) {
    if (input.classList.contains("required")) {
      if (input.value.length === 0 || input.value === input.dataset.empty) {
        input.classList.remove("valid");
        input.classList.add("invalid");

        return !1;
      } else {
        input.classList.remove("invalid");
        input.classList.add("valid");

        return !0;
      }
    }

    return !0;
  }
}
customElements.define("form-state", FormState);

class ListMenuItem extends HTMLElement {
  constructor() {
    super();

    this.listMenuHover =
      this.closest("menu-drawer").querySelector("list-menu-hover");

    this.addEventListener("mouseenter", () => {
      this.listMenuHover.open({
        title: this.dataset.title,
        url: this.dataset.url,
        image: this.dataset.image,
        description: this.dataset.description,
      });
    });
  }
}
customElements.define("list-menu-item", ListMenuItem);

class ListMenuHover extends HTMLElement {
  constructor() {
    super();
  }

  open(obj) {
    let html = "";
    const opened = obj.image.length > 0 || obj.description.length > 0;

    if (opened) {
      html += `<a href="${obj.url}" class="hover-collection${obj.image.length > 0 ? "" : " hover-collection--no-image"
        }">`;
      html +=
        '<figure class="hover-collection__image"' +
        (obj.image.length > 0
          ? `style="background-image:url(${obj.image})"`
          : "") +
        "></figure>";
      html += '<div class="hover-collection__content">';
      html += `<span class="hover-collection__title h4">${obj.title}</span>`;
      html +=
        obj.description.length > 0
          ? `<div class="hover-collection__description">${obj.description}</div>`
          : "";
      html += "</div>";
      html += "</a>";
    }

    this.innerHTML = html;
  }

  close() {
    this.innerHTML = "";
  }
}
customElements.define("list-menu-hover", ListMenuHover);

class TransparentHeader extends HTMLElement {
  constructor() {
    super();

    const header = document.querySelector(".shopify-section-header");

    header.classList.add("transparent-header");
    if (this.dataset.showSeparator == "true") {
      header.classList.add("transparent-separator");
    }
  }
}
customElements.define("transparent-header", TransparentHeader);

class AddToCart extends HTMLElement {
  constructor() {
    super();

    this.miniCart = document.querySelector("mini-cart");
    this.addEventListener("click", this.onClickHandler.bind(this));
  }

  onClickHandler() {
    const variantId = this.dataset.variantId;

    if (variantId) {
      if (
        document.body.classList.contains("template-cart") ||
        !theme.shopSettings.cartDrawer
      ) {
        Shopify.postLink(theme.routes.cart_add_url, {
          parameters: {
            id: variantId,
            quantity: 1,
          },
        });
        return;
      }

      this.setAttribute("disabled", true);
      this.classList.add("loading");
      const sections = this.miniCart
        ? this.miniCart.getSectionsToRender().map((section) => section.id)
        : [];

      const body = JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: sections,
        sections_url: window.location.pathname,
      });

      fetch(`${theme.routes.cart_add_url}`, {
        ...fetchConfig("javascript"),
        body,
      })
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status === 422) {
            document.dispatchEvent(
              new CustomEvent("ajaxProduct:error", {
                detail: {
                  errorMessage: parsedState.description,
                },
              })
            );
          } else {
            this.miniCart && this.miniCart.renderContents(parsedState);

            document.dispatchEvent(
              new CustomEvent("ajaxProduct:added", {
                detail: {
                  product: parsedState,
                },
              })
            );
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.classList.remove("loading");
          this.removeAttribute("disabled");
        });
    }
  }
}
customElements.define("add-to-cart", AddToCart);

class PriceMoney extends HTMLElement {
  constructor() {
    super();

    if (this.shouldInit()) {
      this.init();
    }
  }

  shouldInit() {
    if (document.body.dataset.priceSuperscript === undefined) {
      return false;
    }

    const moneyFormat = theme.shopSettings.moneyFormat.toLowerCase();
    if (moneyFormat.indexOf("class=") !== -1) {
      return false;
    }

    return true;
  }

  init() {
    const currencies_using_comma_decimals =
      "ANG,ARS,BRL,BYN,BYR,CLF,CLP,COP,CRC,CZK,DKK,EUR,HRK,HUF,IDR,ISK,MZN,NOK,PLN,RON,RUB,SEK,TRY,UYU,VES,VND".split(
        ","
      );
    const symbol = theme.shopSettings.moneyFormat.replace(/\{{.*}}/, "").trim();
    const bdi = this.querySelector("bdi");
    const price = bdi.textContent.replace(theme.shopSettings.isoCode, "");
    let html = price.replace(" ", "");
    let money_symbol_decimal = ".";
    if (currencies_using_comma_decimals.includes(theme.shopSettings.isoCode)) {
      money_symbol_decimal = ",";
    }
    if (price.includes(money_symbol_decimal)) {
      if (price.lastIndexOf(symbol) + symbol.length === price.length) {
        const price_without_symbol = price.slice(0, price.lastIndexOf(symbol));
        const price_without_decimal = price.slice(
          0,
          price.lastIndexOf(money_symbol_decimal)
        );
        const decimal = price_without_symbol
          .replace(price_without_decimal, "")
          .trim();
        html = html.replace(
          decimal,
          `<sup class="price__suffix">${decimal}</sup>`
        );
      } else {
        const price_without_decimal = price.slice(
          0,
          price.lastIndexOf(money_symbol_decimal)
        );
        const decimal = price.replace(price_without_decimal, "").trim();
        html = html.replace(
          decimal,
          `<sup class="price__suffix">${decimal}</sup>`
        );
      }
    }
    html = html.replace(symbol, `<span class="price__prefix">${symbol}</span>`);
    if (theme.shopSettings.currencyCode) {
      html = html + " " + theme.shopSettings.isoCode;
    }
    bdi.innerHTML = html;
  }
}
customElements.define("price-money", PriceMoney);

class SlideshowComponent extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      small: this.querySelector(".slideshow__left"),
      content: this.querySelector(".slideshow__content"),
      large: this.querySelector(".slideshow__right"),
    };
    this.settings = {
      autorotate: this.dataset.autorotate == "true",
      autorotateSpeed: parseInt(this.dataset.autorotateSpeed),
      slidesSmall: this.elements.small.querySelectorAll(".slideshow__image"),
      slidesLarge: this.elements.large.querySelectorAll(".slideshow__image"),
    };

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600,
    });
    this.matchMedia();
  }

  init() {
    setTimeout(() => {
      // Only init small carousel if it's visible (hidden in legacy mode and smaller screens)
      this.isSmallVisible = this.elements.small && this.elements.small.offsetParent !== null;

      if (this.isSmallVisible) {
        this.flickitySmall = new Flickity(this.elements.small, {
          accessibility: false,
          rightToLeft: theme.config.rtl,
          prevNextButtons: false,
          pageDots: false,
          wrapAround: true,
          draggable: false,
          setGallerySize: false,
          autoPlay: this.settings.autorotate
            ? this.settings.autorotateSpeed
            : false,
        });
      }

      const contentOptions = {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true,
        draggable: theme.config.mqlSmall ? true : false,
        adaptiveHeight: true,
        arrowShape:
          "M29.043 19.756l-28.125 28.125c-0.605 0.606-0.918 1.406-0.918 2.031s0.305 1.599 0.916 2.209l28.125 28.125c1.221 1.221 3.199 1.221 4.418 0s1.221-3.199 0-4.418l-22.793-22.793h86.209c1.727 0 3.125-1.398 3.125-2.949 0-1.727-1.398-3.125-3.125-3.125h-86.211l22.793-22.793c1.221-1.221 1.221-3.199 0-4.418s-3.203-1.217-4.414 0.006z",
        on: {
          ready: () => {
            const prevNextButtons = this.querySelectorAll(".flickity-button");
            if (prevNextButtons) {
              prevNextButtons.forEach((button) => {
                button.setAttribute("tabindex", "-1");
              });
            }
          },
        },
      };

      if (this.isSmallVisible) {
        contentOptions.asNavFor = this.elements.small;
      } else if (this.settings.autorotate) {
        contentOptions.autoPlay = this.settings.autorotateSpeed;
      }

      this.flickityContent = new Flickity(this.elements.content, contentOptions);

      this.flickityLarge = new Flickity(this.elements.large, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        draggable: true,
        setGallerySize: false,
        asNavFor: this.elements.content,
        dragThreshold: 10,
      });

      this.bindEvents();
    });
  }

  bindEvents() {
    if (this.flickitySmall) {
      this.flickitySmall.on("scroll", () => {
        this.flickitySmall.slides.forEach((slide, i) => {
          const flickity = this.flickitySmall;
          const image = this.settings.slidesSmall[i];
          let x = 0;

          if (image) {
            if (0 === i) {
              x =
                Math.abs(flickity.x) > flickity.slidesWidth
                  ? flickity.slidesWidth +
                  flickity.x +
                  flickity.slides[flickity.slides.length - 1].outerWidth +
                  slide.target
                  : slide.target + flickity.x;
            } else if (i === flickity.slides.length - 1) {
              x =
                Math.abs(flickity.x) + flickity.slides[i].outerWidth <
                  flickity.slidesWidth
                  ? slide.target -
                  flickity.slidesWidth +
                  flickity.x -
                  flickity.slides[i].outerWidth
                  : slide.target + flickity.x;
            } else {
              x = slide.target + flickity.x;
            }

            if (!theme.config.isTouch && !theme.config.rtl) {
              image.style.transform = "translateX(" + x * (-1 / 2) + "px)";
            }
          }
        });
      });
    }

    this.flickityLarge.on("scroll", () => {
      this.flickityLarge.slides.forEach((slide, i) => {
        const flickity = this.flickityLarge;
        const image = this.settings.slidesLarge[i];
        let x = 0;

        if (image) {
          if (0 === i) {
            x =
              Math.abs(flickity.x) > flickity.slidesWidth
                ? flickity.slidesWidth +
                flickity.x +
                flickity.slides[flickity.slides.length - 1].outerWidth +
                slide.target
                : slide.target + flickity.x;
          } else if (i === flickity.slides.length - 1) {
            x =
              Math.abs(flickity.x) + flickity.slides[i].outerWidth <
                flickity.slidesWidth
                ? slide.target -
                flickity.slidesWidth +
                flickity.x -
                flickity.slides[i].outerWidth
                : slide.target + flickity.x;
          } else {
            x = slide.target + flickity.x;
          }

          if (!theme.config.isTouch && !theme.config.rtl) {
            image.style.transform = "translateX(" + x * (-1 / 2) + "px)";
          }
        }
      });
    });

    this.elements.content
      .querySelector(".flickity-button.next")
      .addEventListener("click", () => {
        this.flickitySmall && this.flickitySmall.next();
        this.stopPlayer();
      });

    this.elements.content
      .querySelector(".flickity-button.previous")
      .addEventListener("click", () => {
        this.flickitySmall && this.flickitySmall.previous();
        this.stopPlayer();
      });

    this.elements.content
      .querySelectorAll(".flickity-page-dot")
      .forEach((button) => {
        button.addEventListener("click", () => {
          this.stopPlayer();
        });
      });

    let currentIndex = null,
      swipeDirection = null;

    // Detect swipe direction
    this.flickityLarge.on("dragMove", (_event, _pointer, moveVector) => {
      currentIndex = this.flickityLarge.selectedIndex;
      swipeDirection = this.getSwipeDirection(moveVector);

      this.stopPlayer();
    });

    // Do stuff based on a successful swipe and it's direction
    this.flickityLarge.on("dragEnd", () => {
      if (this.flickityLarge.selectedIndex !== currentIndex && this.flickitySmall) {
        if (swipeDirection === "left") {
          this.flickitySmall.next();
        } else {
          this.flickitySmall.previous();
        }
      }
    });
  }

  stopPlayer() {
    if (this.settings.autorotate) {
      if (this.flickitySmall) {
        this.flickitySmall.stopPlayer();
      } else if (this.flickityContent) {
        this.flickityContent.stopPlayer();
      }
    }
  }

  getSwipeDirection(moveVector) {
    return moveVector.x > 0 ? "right" : "left";
  }

  matchMedia() {
    document.addEventListener("matchSmall", () => {
      this.unload();
      this.init();
    });

    document.addEventListener("unmatchSmall", () => {
      this.unload();
      this.init();
    });
  }

  unload() {
    if (
      this.flickitySmall &&
      typeof this.flickitySmall.destroy === "function"
    ) {
      this.flickitySmall.destroy();
    }
    if (
      this.flickityContent &&
      typeof this.flickityContent.destroy === "function"
    ) {
      this.flickityContent.destroy();
    }
    if (
      this.flickityLarge &&
      typeof this.flickityLarge.destroy === "function"
    ) {
      this.flickityLarge.destroy();
    }
  }
}
customElements.define("slideshow-component", SlideshowComponent);

class TestimonialsComponent extends HTMLElement {
  constructor() {
    super();

    if (this.dataset.slider == "true") {
      this.settings = {
        autorotate: this.dataset.autorotate == "true",
        autorotateSpeed: parseInt(this.dataset.autorotateSpeed),
      };
      this.slider = this.querySelector(".testimonial__list");
      this.previews = this.querySelector(".testimonial__previews");

      theme.initWhenVisible({
        element: this,
        callback: this.init.bind(this),
        threshold: 600,
      });
      theme.initWhenVisible({
        element: this,
        callback: this.update.bind(this),
        threshold: 0,
      });
    }
  }

  init() {
    setTimeout(() => {
      if (this.slider) {
        this.flickity = new Flickity(this.slider, {
          accessibility: false,
          rightToLeft: theme.config.rtl,
          prevNextButtons: true,
          arrowShape:
            "M29.043 19.756l-28.125 28.125c-0.605 0.606-0.918 1.406-0.918 2.031s0.305 1.599 0.916 2.209l28.125 28.125c1.221 1.221 3.199 1.221 4.418 0s1.221-3.199 0-4.418l-22.793-22.793h86.209c1.727 0 3.125-1.398 3.125-2.949 0-1.727-1.398-3.125-3.125-3.125h-86.211l22.793-22.793c1.221-1.221 1.221-3.199 0-4.418s-3.203-1.217-4.414 0.006z",
          pageDots: false,
          wrapAround: true,
          draggable: true,
          cellAlign: "center",
          autoPlay: this.settings.autorotate
            ? this.settings.autorotateSpeed
            : false,
          pauseAutoPlayOnHover: true,
          asNavFor: this.previews,
        });
      }

      this.flickityNav = new Flickity(this.previews, {
        accessibility: false,
        rightToLeft: theme.config.rtl,
        prevNextButtons: this.flickity ? false : true,
        arrowShape: this.flickity
          ? ""
          : "M29.043 19.756l-28.125 28.125c-0.605 0.606-0.918 1.406-0.918 2.031s0.305 1.599 0.916 2.209l28.125 28.125c1.221 1.221 3.199 1.221 4.418 0s1.221-3.199 0-4.418l-22.793-22.793h86.209c1.727 0 3.125-1.398 3.125-2.949 0-1.727-1.398-3.125-3.125-3.125h-86.211l22.793-22.793c1.221-1.221 1.221-3.199 0-4.418s-3.203-1.217-4.414 0.006z",
        pageDots: false,
        wrapAround: true,
        selectedAttraction: 0.2,
        friction: 0.8,
        adaptiveHeight: true,
      });

      this.flickityNav.previous();
      if (this.settings.autorotate) {
        this.flickity.pausePlayer();
      }

      this.flickity &&
        this.flickity.on(
          "staticClick",
          (_event, _pointer, _cellElement, cellIndex) => {
            if (typeof cellIndex == "number") {
              this.flickityNav.select(cellIndex);
            }
          }
        );

      // Do stuff based on a successful swipe and it's direction
      this.flickity &&
        this.flickity.on("change", (index) => {
          this.flickityNav.select(index);
        });
    });
  }

  update() {
    setTimeout(() => {
      if (this.flickity && this.flickityNav) {
        this.flickityNav.next();
        if (this.settings.autorotate) {
          this.flickity.unpausePlayer();
        }
      }
    }, 300);
  }

  getSwipeDirection(moveVector) {
    return moveVector.x > 0 ? "right" : "left";
  }
}
customElements.define("testimonials-component", TestimonialsComponent);

class UseAnimate extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 0,
    });
  }

  init() {
    this.setAttribute("animate", "");
  }
}
customElements.define("use-animate", UseAnimate);

class AnimateSticky extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.onScrollHandler = this.onScroll.bind(this);

    window.addEventListener("scroll", this.onScrollHandler, false);
    this.onScrollHandler();
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScrollHandler);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.getOffsetTop(this)) {
      window.requestAnimationFrame(this.reveal.bind(this));
    } else {
      window.requestAnimationFrame(this.reset.bind(this));
    }
  }

  reveal() {
    this.setAttribute("animate", "");
  }

  reset() {
    this.removeAttribute("animate");
  }

  getOffsetTop(element) {
    let offsetTop = 0;
    while (element) {
      offsetTop += element.offsetTop;
      element = element.offsetParent;
    }
    return offsetTop;
  }
}
customElements.define("animate-sticky", AnimateSticky);

class LookbookComponent extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 0,
    });
  }

  init() {
    const hotspots = this.querySelectorAll(".look__hotspot");
    hotspots.forEach((hotspot) => {
      hotspot.classList.add("is-active");
    });

    setTimeout(() => {
      hotspots.forEach((hotspot) => {
        hotspot.classList.remove("is-active");
      });
    }, 3e3);
  }
}
customElements.define("lookbook-component", LookbookComponent);

class TabCollage extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll(".tab-collage__heading").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );

    if (this.dataset.accordion === undefined) {
      this.querySelectorAll(".tab-collage__heading").forEach((button) =>
        button.addEventListener("mouseover", this.onButtonClick.bind(this))
      );
    }
  }

  onButtonClick(event) {
    const target = event.target;
    if (target.classList.contains("is-active")) {
      if (this.dataset.accordion !== undefined) {
        target.classList.remove("is-active");
      }
      return;
    }

    this.pauseAllMedia();

    this.querySelectorAll("[data-block-id]").forEach((button) => {
      if (target.dataset.blockId === button.dataset.blockId) {
        button.classList.add("is-active");
      } else {
        button.classList.remove("is-active");
      }
    });
  }

  pauseAllMedia() {
    this.querySelectorAll('video-section[data-type="youtube"] iframe').forEach(
      (video) => {
        video.contentWindow.postMessage(
          '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
          "*"
        );
      }
    );
    this.querySelectorAll('video-section[data-type="vimeo"] iframe').forEach(
      (video) => {
        video.contentWindow.postMessage('{"method":"pause"}', "*");
      }
    );
    this.querySelectorAll("video").forEach((video) => video.pause());
    document.querySelectorAll("video").forEach((video) => video.pause());
  }
}
customElements.define("tab-collage", TabCollage);

class CountdownTimer extends HTMLElement {
  constructor() {
    super();

    this.parent = this.closest(".product-countdown");
    this.date = new Date(Date.parse(this.dataset.date)).getTime();

    if (isNaN(this.date)) {
      this.date = new Date(this.dataset.date.replace(/-/g, "/")).getTime();

      if (isNaN(this.date)) {
        this.unload();
        return;
      }
    }

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200,
    });
  }

  init() {
    this.timer();
    this.dataset.interval = setInterval(this.timer.bind(this), 1000);
  }

  timer() {
    const now = new Date(),
      countTo = new Date(this.date),
      timeDifference = countTo - now;

    if (timeDifference < 0) {
      this.unload();
      return;
    }

    const secondsInADay = 60 * 60 * 1000 * 24,
      secondsInAHour = 60 * 60 * 1000;

    const days = Math.floor((timeDifference / secondsInADay) * 1);
    const hours = Math.floor(
      ((timeDifference % secondsInADay) / secondsInAHour) * 1
    );
    const mins = Math.floor(
      (((timeDifference % secondsInADay) % secondsInAHour) / (60 * 1000)) * 1
    );
    const secs = Math.floor(
      ((((timeDifference % secondsInADay) % secondsInAHour) % (60 * 1000)) /
        1000) *
      1
    );

    if (this.dataset.compact == "true") {
      const dayHTML =
        days > 0
          ? `<div class="countdown__item"><span>${days}${theme.dateStrings.d}</span></div>`
          : "";
      const otherHTML = `<div class="countdown__item"><span>${hours > 9 ? hours : "0" + hours
        }:${mins > 9 ? mins : "0" + mins}:${secs > 9 ? secs : "0" + secs
        }</span></div>`;

      this.innerHTML = dayHTML + otherHTML;
    } else {
      const dayHTML =
        days > 0
          ? `<div class="countdown__item"><span>${days}</span> ${days == 1 ? theme.dateStrings.day : theme.dateStrings.days
          }</div>`
          : "";
      const hourHTML = `<div class="countdown__item"><span>${hours}</span> ${hours == 1 ? theme.dateStrings.hour : theme.dateStrings.hours
        }</div>`;
      const minHTML = `<div class="countdown__item"><span>${mins}</span> ${mins == 1 ? theme.dateStrings.minute : theme.dateStrings.minutes
        }</div>`;
      const secHTML = `<div class="countdown__item"><span>${secs}</span> ${secs == 1 ? theme.dateStrings.second : theme.dateStrings.seconds
        }</div>`;

      this.innerHTML = dayHTML + hourHTML + minHTML + secHTML;
    }
  }

  unload() {
    if (this.dataset.interval) {
      clearInterval(this.dataset.interval);
    }

    this.classList.add("hidden");
    if (this.parent) {
      this.parent.classList.add("hidden");
    }
  }
}
customElements.define("countdown-timer", CountdownTimer);

class GMap extends HTMLElement {
  constructor() {
    super();

    if (!this.dataset.apiKey || !this.dataset.mapAddress) {
      return;
    }

    theme.initWhenVisible({
      element: this,
      callback: this.prepMapApi.bind(this),
      threshold: 200,
    });
  }

  prepMapApi() {
    this.loadScript().then(this.initMap.bind(this));
  }

  loadScript() {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      document.body.appendChild(script);
      script.onload = resolve;
      script.onerror = reject;
      script.async = true;
      script.src =
        "https://maps.googleapis.com/maps/api/js?key=" + this.dataset.apiKey;
    });
  }

  initMap() {
    const geocoder = new google.maps.Geocoder();

    geocoder.geocode(
      { address: this.dataset.mapAddress },
      (results, status) => {
        if (status !== google.maps.GeocoderStatus.OK) {
          if (Shopify.designMode) {
          }
        } else {
          const mapOptions = {
            zoom: parseInt(this.dataset.zoom),
            center: results[0].geometry.location,
            draggable: true,
            clickableIcons: false,
            scrollwheel: false,
            disableDoubleClickZoom: true,
            disableDefaultUI: true,
          };

          const map = new google.maps.Map(this, mapOptions),
            center = map.getCenter();

          map.setCenter(center);

          const icon = {
            path: "M32.7374478,5.617 C29.1154478,1.995 24.2994478,0 19.1774478,0 C14.0544478,0 9.23944778,1.995 5.61744778,5.617 C-1.08555222,12.319 -1.91855222,24.929 3.81344778,32.569 L19.1774478,54.757 L34.5184478,32.6 C40.2734478,24.929 39.4404478,12.319 32.7374478,5.617 Z M19.3544478,26 C15.4954478,26 12.3544478,22.859 12.3544478,19 C12.3544478,15.141 15.4954478,12 19.3544478,12 C23.2134478,12 26.3544478,15.141 26.3544478,19 C26.3544478,22.859 23.2134478,26 19.3544478,26 Z",
            fillColor: this.dataset.markerColor,
            fillOpacity: 1,
            anchor: new google.maps.Point(15, 55),
            strokeWeight: 0,
            scale: 0.6,
          };

          new google.maps.Marker({
            map: map,
            position: map.getCenter(),
            icon: icon,
          });

          const styledMapType = new google.maps.StyledMapType(
            JSON.parse(
              this.parentNode.querySelector("[data-gmap-style]").innerHTML
            )
          );

          map.mapTypes.set("styled_map", styledMapType);
          map.setMapTypeId("styled_map");

          google.maps.event.addDomListener(window, "resize", function () {
            google.maps.event.trigger(map, "resize");
            map.setCenter(center);
          });
        }
      }
    );
  }
}
customElements.define("g-map", GMap);

class RelatedButtons extends HTMLElement {
  constructor() {
    super();

    if (!document.querySelector(this.dataset.scrollto)) {
      this.classList.add("hidden");
      return;
    }

    window.addEventListener("scroll", this.checkListener.bind(this));
    this.querySelectorAll("a").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  checkListener() {
    const element = document.querySelector(this.dataset.scrollto);
    const show = window.scrollY >= element.offsetTop - element.clientHeight;

    if (show) {
      this.classList.add("is-flipped");
    } else {
      this.classList.remove("is-flipped");
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const target = event.target;
    const scrollIntoView = document.querySelector(target.getAttribute("href"));

    scrollIntoView.scrollIntoView({ behavior: "smooth" });
  }
}
customElements.define("related-buttons", RelatedButtons);

class ProductRecentlyViewed extends HTMLElement {
  constructor() {
    super();

    // We save the product ID in local storage to be eventually used for recently viewed section
    if (isStorageSupported("local")) {
      const productId = parseInt(this.dataset.productId);
      const cookieName = "beyours:recently-viewed";
      const items = JSON.parse(window.localStorage.getItem(cookieName) || "[]");

      // We check if the current product already exists, and if it does not, we add it at the start
      if (!items.includes(productId)) {
        items.unshift(productId);
      }

      // By keeping only the 4 most recent
      window.localStorage.setItem(
        cookieName,
        JSON.stringify(items.slice(0, 5))
      );
    }
  }
}
customElements.define("product-recently-viewed", ProductRecentlyViewed);

class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600,
    });
  }

  init() {
    fetch(this.dataset.url + this.getQueryString())
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("recently-viewed-products");
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getQueryString() {
    const cookieName = "beyours:recently-viewed";
    const items = JSON.parse(window.localStorage.getItem(cookieName) || "[]");
    if (
      this.dataset.productId &&
      items.includes(parseInt(this.dataset.productId))
    ) {
      items.splice(items.indexOf(parseInt(this.dataset.productId)), 1);
    }
    return items
      .map((item) => "id:" + item)
      .slice(0, 4)
      .join(" OR ");
  }
}
customElements.define("recently-viewed-products", RecentlyViewedProducts);

class VideoSection extends HTMLElement {
  constructor() {
    super();

    this.background = this.dataset.initMode !== "template";
    this.loop = this.dataset.loop;

    if (this.background) {
      theme.initWhenVisible({
        element: this,
        callback: this.init.bind(this),
        threshold: 600,
      });
    } else {
      this.init();
    }
  }

  init() {
    this.parentSelector = this.dataset.parent || ".media-wrapper";
    this.parent = this.closest(this.parentSelector);

    switch (this.dataset.type) {
      case "youtube":
        this.initYoutubeVideo();
        break;

      case "vimeo":
        this.initVimeoVideo();
        break;

      case "mp4":
        this.initMp4Video();
        break;
    }
  }

  initYoutubeVideo() {
    this.setAsLoading();
    this.loadScript("youtube").then(this.setupYoutubePlayer.bind(this));
  }

  initVimeoVideo() {
    this.setAsLoading();
    this.loadScript("vimeo").then(this.setupVimeoPlayer.bind(this));
  }

  initMp4Video() {
    const player = this.querySelector("video");

    if (player) {
      const promise = player.play();

      // Edge does not return a promise (video still plays)
      if (typeof promise !== "undefined") {
        promise
          .then(function () {
            // playback normal
          })
          .catch(function () {
            player.setAttribute("controls", "");
          });
      }
    }
  }

  loadScript(videoType) {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      document.body.appendChild(script);
      script.onload = resolve;
      script.onerror = reject;
      script.async = true;
      script.src =
        videoType === "youtube"
          ? "//www.youtube.com/iframe_api"
          : "//player.vimeo.com/api/player.js";
    });
  }

  setAsLoading() {
    this.parent.setAttribute("loading", true);
  }

  setAsLoaded() {
    this.parent.removeAttribute("loading");
    this.parent.setAttribute("loaded", true);
  }

  setupYoutubePlayer() {
    const videoId = this.dataset.videoId;

    const playerInterval = setInterval(() => {
      if (window.YT) {
        window.YT.ready(() => {
          const element = document.createElement("div");
          this.appendChild(element);

          this.player = new YT.Player(element, {
            videoId: videoId,
            playerVars: {
              showinfo: 0,
              controls: !this.background,
              fs: !this.background,
              rel: 0,
              height: "100%",
              width: "100%",
              iv_load_policy: 3,
              html5: 1,
              loop: this.loop == "1" ? 1 : 0,
              playlist: videoId,
              playsinline: 1,
              modestbranding: 1,
              disablekb: 1,
            },
            events: {
              onReady: this.onYoutubeReady.bind(this),
              onStateChange: this.onYoutubeStateChange.bind(this),
            },
          });
          clearInterval(playerInterval);
        });
      }
    }, 50);
  }

  onYoutubeReady() {
    this.iframe = this.querySelector("iframe"); // iframe once YT loads
    this.iframe.setAttribute("tabindex", "-1");

    this.background && this.player.mute();
    if (typeof this.player.playVideo === "function") this.player.playVideo();

    this.setAsLoaded();

    // pause when out of view
    const observer = new IntersectionObserver(
      (entries, _observer) => {
        entries.forEach((entry) => {
          entry.isIntersecting ? this.youtubePlay() : this.youtubePause();
        });
      },
      { rootMargin: "0px 0px 50px 0px" }
    );

    observer.observe(this.iframe);
  }

  onYoutubeStateChange(event) {
    switch (event.data) {
      case -1: // unstarted
        // Handle low power state on iOS by checking if
        // video is reset to unplayed after attempting to buffer
        if (this.attemptedToPlay) {
          this.setAsLoaded();
          this.closest(".banner").classList.add("video-interactable");
        }
        break;
      case 0: // ended, loop it
        this.youtubePlay();
        break;
      case 1: // playing
        this.setAsLoaded();
        break;
      case 3: // buffering
        this.attemptedToPlay = true;
        break;
    }
  }

  youtubePlay() {
    if (
      this.background &&
      this.player &&
      typeof this.player.playVideo === "function"
    ) {
      this.player.playVideo();
    }
  }

  youtubePause() {
    if (
      this.background &&
      this.player &&
      typeof this.player.pauseVideo === "function"
    ) {
      this.player.pauseVideo();
    }
  }

  setupVimeoPlayer() {
    const videoId = this.dataset.videoId;

    const playerInterval = setInterval(() => {
      if (window.Vimeo) {
        this.player = new Vimeo.Player(this, {
          id: videoId,
          autoplay: true,
          autopause: false,
          background: this.background,
          controls: !this.background,
          loop: this.loop == "1" ? true : false,
          playlist: videoId,
          height: "100%",
          width: "100%",
        });
        this.player.ready().then(this.onVimeoReady.bind(this));

        clearInterval(playerInterval);
      }
    }, 50);
  }

  onVimeoReady() {
    this.iframe = this.querySelector("iframe");
    this.iframe.setAttribute("tabindex", "-1");

    this.background && this.player.setMuted(true);

    this.setAsLoaded();

    // pause when out of view
    const observer = new IntersectionObserver(
      (entries, _observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.vimeoPlay();
          } else {
            this.vimeoPause();
          }
        });
      },
      { rootMargin: "0px 0px 50px 0px" }
    );

    observer.observe(this.iframe);
  }

  vimeoPlay() {
    if (
      this.background &&
      this.player &&
      typeof this.player.play === "function"
    ) {
      this.player.play();
    }
  }

  vimeoPause() {
    if (
      this.background &&
      this.player &&
      typeof this.player.pause === "function"
    ) {
      this.player.pause();
    }
  }
}
customElements.define("video-section", VideoSection);

class BundleProduct extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      souldout: "price--sold-out",
      onsale: "price--on-sale",
      nocompare: "price--no-compare",
    };

    this.addToCart = this.querySelector("add-to-cart");
    this.price = this.querySelector(".price");
    this.variants = this.querySelector("select");
    if (this.variants) {
      this.variants.addEventListener("change", this.onSelectChange.bind(this));
    }
  }

  onSelectChange(event) {
    const variants = event.target;
    const variant = variants.options[variants.selectedIndex];
    const compare_at_price = parseInt(variant.dataset.compare_at_price || 0);
    const price = parseInt(variant.dataset.price || 0);
    const available = variant.dataset.available === "true";
    const price_varies = variants.dataset.price_varies === "true";
    const compare_at_price_varies =
      variants.dataset.compare_at_price_varies === "true";

    // Remove classes
    this.price.classList.remove(this.classes.souldout);
    this.price.classList.remove(this.classes.onsale);
    this.price.classList.remove(this.classes.nocompare);

    // Add classes
    if (available === false) {
      this.price.classList.add(this.classes.souldout);
    } else if (compare_at_price > price && available) {
      this.price.classList.add(this.classes.onsale);
    }
    if (price_varies == false && compare_at_price_varies) {
      this.price.classList.add(this.classes.nocompare);
    }

    // Change price
    const price__regular = this.querySelector(".price__regular");
    price__regular.querySelector(
      ".price-item--regular"
    ).innerHTML = `<price-money><bdi>${theme.Currency.formatMoney(
      price,
      theme.shopSettings.moneyFormat
    )}</bdi></price-money>`;

    const price__sale = this.querySelector(".price__sale");
    price__sale.querySelector(
      ".price-item--regular"
    ).innerHTML = `<price-money><bdi>${theme.Currency.formatMoney(
      compare_at_price,
      theme.shopSettings.moneyFormat
    )}</bdi></price-money>`;
    price__sale.querySelector(
      ".price-item--sale"
    ).innerHTML = `<price-money><bdi>${theme.Currency.formatMoney(
      price,
      theme.shopSettings.moneyFormat
    )}</bdi></price-money>`;

    // Change variant id
    if (this.addToCart) {
      this.addToCart.dataset.variantId = variant.value;
    }
  }
}
customElements.define("bundle-product", BundleProduct);

class BundleProducts extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      hover: "is-hover",
      active: "is-active",
    };

    this.miniCart = document.querySelector("mini-cart");
    this.button = this.querySelector("button");
    if (this.button)
      this.button.addEventListener("click", this.onButtonClick.bind(this));

    this.blocks = this.querySelectorAll("[data-block-id]");
    this.blocks.forEach((block) =>
      block.addEventListener("mouseenter", this.onEnterHandler.bind(this))
    );
    this.blocks.forEach((block) =>
      block.addEventListener("mouseleave", this.onLeaveHandler.bind(this))
    );
  }

  onEnterHandler(event) {
    this.classList.add(this.classes.hover);

    const target = event.target;
    const blockId = target.dataset.blockId;
    this.blocks.forEach((block) => {
      if (target.nodeName === "BUNDLE-PRODUCT") {
        if (block.nodeName === "BUNDLE-PRODUCT") {
          block.classList.add(this.classes.active);
          return;
        }
      }
      if (block.dataset.blockId === blockId) {
        block.classList.add(this.classes.active);
      }
    });
  }

  onLeaveHandler() {
    this.classList.remove(this.classes.hover);
    this.blocks.forEach((block) => block.classList.remove(this.classes.active));
  }

  onButtonClick(event) {
    event.preventDefault();

    const ids = this.querySelectorAll('[name="id"]');
    const items = {
      items: [...ids]
        .map((e) => e.value)
        .map((e) => ({
          id: e,
          quantity: 1,
        })),
    };

    if (
      document.body.classList.contains("template-cart") ||
      !theme.shopSettings.cartDrawer
    ) {
      Shopify.postLink2(theme.routes.cart_add_url, {
        parameters: {
          ...items,
        },
      });
      return;
    }

    this.handleErrorMessage();

    this.button.setAttribute("disabled", true);
    this.button.classList.add("loading");
    const sections = this.miniCart
      ? this.miniCart.getSectionsToRender().map((section) => section.id)
      : [];

    const body = JSON.stringify({
      ...items,
      sections: sections,
      sections_url: window.location.pathname,
    });

    fetch(`${theme.routes.cart_add_url}`, {
      ...fetchConfig("javascript"),
      body,
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }

        if (response.status === 422) {
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:error", {
              detail: {
                errorMessage: response.description,
              },
            })
          );
        } else {
          this.miniCart && this.miniCart.renderContents(response);

          document.dispatchEvent(
            new CustomEvent("ajaxProduct:added", {
              detail: {
                product: response,
              },
            })
          );
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.button.classList.remove("loading");
        this.button.removeAttribute("disabled");
      });
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper =
      this.errorMessageWrapper ||
      this.querySelector(".product-form__error-message-wrapper");

    if (this.errorMessageWrapper) {
      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper.querySelector(".product-form__error-message");
      this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    } else {
      if (errorMessage) {
        alert(errorMessage);
      }
    }
  }
}
customElements.define("bundle-products", BundleProducts);

class ShopTheLook extends HTMLElement {
  constructor() {
    super();

    if (this.dataset.blockCount == 1) {
      return;
    }

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600,
    });
  }

  init() {
    this.products = this.querySelector(".image-with-text__products");

    this.blocks = this.querySelectorAll(
      "lookbook-component [data-block-index]"
    );
    this.blocks.forEach((block) =>
      block.addEventListener("mouseenter", this.onEnterHandler.bind(this))
    );

    this.initSlider();
  }

  onEnterHandler(event) {
    if (this.flickity && typeof this.flickity.select === "function") {
      const index = parseInt(event.target.dataset.blockIndex);
      this.flickity.select(index);
    }
  }

  onFocusHandler(index) {
    this.blocks.forEach((block) => {
      block.classList.remove("focus");

      if (parseInt(block.dataset.blockIndex) === index) {
        block.classList.add("focus");
      }
    });
  }

  initSlider() {
    this.flickity = new Flickity(this.products, {
      accessibility: false,
      rightToLeft: theme.config.rtl,
      prevNextButtons: false,
      pageDots: true,
      wrapAround: true,
      fade: true,
      setGallerySize: true,
      on: {
        ready: () => {
          this.onFocusHandler(0);
        },
        change: (index) => {
          this.onFocusHandler(index);
        },
      },
    });
  }
}
customElements.define("shop-the-look", ShopTheLook);

class SelectWrapper extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200,
    });

    this.select = this.querySelector("select");
    if (this.select) {
      this.select.addEventListener(
        "change",
        this.handleSelectChange.bind(this)
      );
    }
  }

  init() {
    const style = window.getComputedStyle(this.select);
    const value = this.select.options[this.select.selectedIndex].text;

    const text = document.createElement("span");
    text.style.fontFamily = style.fontFamily;
    text.style.fontSize = style.fontSize;
    text.style.fontWeight = style.fontWeight;
    text.style.visibility = "hidden";
    text.style.position = "absolute";
    text.innerHTML = value;

    document.body.appendChild(text);
    const width = text.clientWidth;

    this.style.setProperty("--width", `${width}px`);
    text.remove();
  }

  handleSelectChange() {
    this.init();
  }
}
customElements.define("select-wrapper", SelectWrapper);

class ImageComparison extends HTMLElement {
  constructor() {
    super();

    this.active = false;
    this.button = this.querySelector("button");
    this.horizontal = this.dataset.layout === "horizontal";
    this.bodyStyleOverflowY = document.body.style.overflowY;
    this.init();

    theme.initWhenVisible({
      element: this.querySelector(".image-comparison__animate"),
      callback: this.animate.bind(this),
      threshold: 0,
    });
  }

  animate() {
    this.setAttribute("animate", "");
    this.classList.add("animating");
    setTimeout(() => {
      this.classList.remove("animating");
    }, 1e3);
  }

  init() {
    this.button.addEventListener("touchstart", this.startHandler.bind(this));
    document.body.addEventListener("touchend", this.endHandler.bind(this));
    document.body.addEventListener("touchmove", this.onHandler.bind(this));

    this.button.addEventListener("mousedown", this.startHandler.bind(this));
    document.body.addEventListener("mouseup", this.endHandler.bind(this));
    document.body.addEventListener("mousemove", this.onHandler.bind(this));
  }

  startHandler() {
    if (window.innerWidth <= 750) {
      document.body.style.overflowY = "hidden";
    }

    this.active = true;
    this.classList.add("scrolling");
  }

  endHandler() {
    this.active = false;
    this.classList.remove("scrolling");
    document.body.style.overflowY = this.bodyStyleOverflowY;
  }

  onHandler(e) {
    if (!this.active) return;

    const event = (e.touches && e.touches[0]) || e;
    const x = this.horizontal
      ? event.pageX - this.offsetLeft
      : event.pageY - this.offsetTop;

    this.scrollIt(x);
  }

  scrollIt(x) {
    const distance = this.horizontal ? this.clientWidth : this.clientHeight;

    const max = distance - 20;
    const min = 20;
    const mouseX = Math.max(min, Math.min(x, max));
    const mousePercent = (mouseX * 100) / distance;
    this.style.setProperty("--percent", mousePercent + "%");
  }
}
customElements.define("image-comparison", ImageComparison);

class ScrollingPromotion extends HTMLElement {
  constructor() {
    super();

    this.config = {
      moveTime: parseFloat(this.dataset.speed), // 100px going to move for
      space: 100, // 100px
    };

    this.promotion = this.querySelector(".promotion");

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600,
    });
  }

  init() {
    if (this.childElementCount === 1) {
      this.promotion.classList.add("promotion--animated");

      for (let index = 0; index < 10; index++) {
        this.clone = this.promotion.cloneNode(true);
        this.clone.setAttribute("aria-hidden", true);
        this.appendChild(this.clone);

        const imageWrapper = this.clone.querySelector(".media-wrapper");
        if (imageWrapper) {
          imageWrapper.classList.remove("loading");
        }
      }

      const animationTimeFrame =
        (this.promotion.clientWidth / this.config.space) * this.config.moveTime;
      this.style.setProperty("--duration", `${animationTimeFrame}s`);

      // pause when out of view
      const observer = new IntersectionObserver(
        (entries, _observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.scrollingPlay();
            } else {
              this.scrollingPause();
            }
          });
        },
        { rootMargin: "0px 0px 50px 0px" }
      );

      observer.observe(this);
    }
  }

  scrollingPlay() {
    this.classList.remove("scrolling-promotion--paused");
  }

  scrollingPause() {
    this.classList.add("scrolling-promotion--paused");
  }
}
customElements.define("scrolling-promotion", ScrollingPromotion);

class AccordionTab extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector("details");
    this.summary = this.querySelector("summary");
    this.content = this.querySelector(".accordion__content");

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200,
    });
  }

  init() {
    this.summary.addEventListener("click", (e) => this.onClick(e));
  }

  onClick(e) {
    e.preventDefault();

    this.details.style.overflow = "hidden";
    if (this.isClosing || !this.details.open) {
      this.open();
    } else if (this.isExpanding || this.details.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;

    const summaryStyle = window.getComputedStyle(this.summary);
    const startHeight = `${this.details.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + parseInt(summaryStyle.marginTop)
      }px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.details.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 250,
        easing: "ease",
      }
    );

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => (this.isClosing = false);
  }

  open() {
    this.details.style.height = `${this.details.offsetHeight}px`;
    this.details.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;

    const summaryStyle = window.getComputedStyle(this.summary);
    const startHeight = `${this.details.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight +
      parseInt(summaryStyle.marginTop) +
      this.content.offsetHeight
      }px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.details.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 400,
        easing: "ease-out",
      }
    );
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  onAnimationFinish(open) {
    this.details.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.details.style.height = this.details.style.overflow = "";
  }
}
customElements.define("accordion-tab", AccordionTab);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this), {
      rootMargin: "0px 0px 600px 0px",
    }).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define("product-recommendations", ProductRecommendations);

class HeaderMenuToggle extends HTMLElement {
  constructor() {
    super();

    this.header = document.querySelector(".shopify-section-header");
    this.addEventListener("click", this.onButtonClick.bind(this));
  }

  onButtonClick() {
    this.header.classList.toggle("shopify-section-header-menu-open");
  }
}
customElements.define("header-menu-toggle", HeaderMenuToggle);

class OptionTable extends HTMLElement {
  constructor() {
    super();

    this.config = {};

    this.imageOptionRows = this.querySelectorAll(".ot--images .ot--option-row");
    this.dataOptionRows = this.querySelectorAll(".ot--data .ot--option-row");

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600,
    });
  }

  init() {
    const optionTable = this;

    this.imageOptionRows.forEach((imageOptionRow) => {
      imageOptionRow.addEventListener("mouseenter", function () {
        optionTable
          .querySelectorAll(".ot--data .ot--option-row")
          .forEach((el) => {
            el.classList.remove("active");
          });
        optionTable
          .querySelectorAll(".ot--images .ot--option-row")
          .forEach((el) => {
            el.style.opacity = "0.3";
          });
        optionTable
          .querySelectorAll(".ot--images .ot--option-row")
          .forEach((el) => {
            el.style.zIndex = "initial";
          });

        this.style.opacity = "1";
        this.style.zIndex = "3";

        var imageRowId = this.id;
        var dataRowId = imageRowId.replace("imageRow", "dataRow");
        var activeDataRow = optionTable.querySelector(`#${dataRowId}`);
        activeDataRow.classList.add("active");

        optionTable
          .querySelectorAll(`:scope .data-row.data-headers>div:not(.blank)`)
          .forEach((el) => {
            el.classList.remove("active");
          });
        var activeDataRowValues = activeDataRow.querySelectorAll(
          `:scope div:not(.is-header)`
        );
        activeDataRowValues.forEach((activeDataRowValue, i) => {
          if (
            activeDataRowValue.querySelectorAll(`:scope svg.checkmark`).length >
            0
          ) {
            optionTable
              .querySelectorAll(`:scope .data-row.data-headers>div:not(.blank)`)
            [i].classList.add("active");
          }
        });
      });
      imageOptionRow.addEventListener("mouseleave", function () {
        optionTable
          .querySelectorAll(".ot--data .ot--option-row")
          .forEach((el) => {
            el.classList.remove("active");
          });
        optionTable
          .querySelectorAll(".ot--images .ot--option-row")
          .forEach((el) => {
            el.style.opacity = "1";
          });
        optionTable
          .querySelectorAll(`:scope .data-row.data-headers>div:not(.blank)`)
          .forEach((el) => {
            el.classList.remove("active");
          });
      });
    });

    this.dataOptionRows.forEach((dataOptionRow) => {
      dataOptionRow.addEventListener("mouseenter", function () {
        optionTable
          .querySelectorAll(".ot--data .ot--option-row")
          .forEach((el) => {
            el.classList.remove("active");
          });
        this.classList.add("active");
        optionTable
          .querySelectorAll(".ot--images .ot--option-row")
          .forEach((el) => {
            el.style.opacity = "0.3";
          });
        optionTable
          .querySelectorAll(".ot--images .ot--option-row")
          .forEach((el) => {
            el.style.zIndex = "initial";
          });

        var dataRowId = this.id;
        var imageRowId = dataRowId.replace("dataRow", "imageRow");
        optionTable.querySelector(`#${imageRowId}`).style.opacity = "1";
        optionTable.querySelector(`#${imageRowId}`).style.zIndex = "3";
      });
      dataOptionRow.addEventListener("mouseleave", function () {
        optionTable
          .querySelectorAll(".ot--data .ot--option-row")
          .forEach((el) => {
            el.classList.remove("active");
          });
        optionTable
          .querySelectorAll(".ot--images .ot--option-row")
          .forEach((el) => {
            el.style.opacity = "1";
          });
        optionTable
          .querySelectorAll(`:scope .data-row.data-headers>div:not(.blank)`)
          .forEach((el) => {
            el.classList.remove("active");
          });
      });
    });
  }
}
customElements.define("option-table", OptionTable);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      input: this.querySelector(
        'input[name="locale_code"], input[name="country_code"]'
      ),
      button: this.querySelector("button"),
      panel: this.querySelector("ul"),
    };

    this.elements.button.addEventListener(
      "click",
      this.openSelector.bind(this)
    );
    this.elements.button.addEventListener(
      "focusout",
      this.closeSelector.bind(this)
    );
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);

    if (this.classList.contains("on-header")) {
      document.body.classList.remove("localization--open");
    }
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    this.hidePanel();
    // this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    // this.elements.button.focus();
    this.elements.panel.toggleAttribute("hidden");
    this.elements.button.setAttribute(
      "aria-expanded",
      (
        this.elements.button.getAttribute("aria-expanded") === "false"
      ).toString()
    );

    if (this.classList.contains("on-header")) {
      document.body.classList.toggle("localization--open");
    }
  }

  closeSelector(event) {
    const shouldClose =
      event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define("localization-form", LocalizationForm);

/************************************************************************************

* GLOBAL COMPONENTS

*************************************************************************************/
if (!customElements.get("l-swiper-carousel")) {
  customElements.define(
    "l-swiper-carousel",
    class LTASwiperCarousel extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        // Check if Swiper is already loaded
        this.setupCarousel();
      }

      setupCarousel() {
        this.carouselConfig = JSON.parse(
          this.querySelector("[data-carousel-config]").textContent
        );

        if (!this.carouselConfig) return;

        this.classList.remove("is-placeholder");

        this.flickity = new Flickity(this, this.carouselConfig);
      }
    }
  );
}

if (!customElements.get("l-swiper-carousel-v2")) {
  customElements.define(
    "l-swiper-carousel-v2",
    class LTASwiperCarousel extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        // Check if Swiper is already loaded
        if (window.Swiper) {
          this.setupCarousel();

          return;
        }

        document.addEventListener("l:vendor:loaded", () => {
          this.setupCarousel();
        });
      }

      setupCarousel() {
        this.carouselConfig = JSON.parse(
          this.querySelector("[data-carousel-config]").textContent
        );

        if (!this.carouselConfig) return;

        this.swiperSlideEls = this.querySelectorAll(".swiper-slide");

        this.classList.remove("is-placeholder");
        this.swiperSlideEls.forEach((swiperSlide) =>
          swiperSlide.classList.remove("l-hidden")
        );

        this.swiperCarousel = new window.Swiper(this, this.carouselConfig);

        Shopify.designMode && this.designModeScroll();
      }

      designModeScroll() {
        document.addEventListener("shopify:block:select", (event) => {
          const targetEl = event.target;

          this.swiperSlideEls.forEach((swiperSlide, index0) => {
            if (targetEl == swiperSlide) this.slideTo(index0);
          });
        });
      }

      slideTo(index = 0) {
        this.swiperCarousel.slideTo(index);
      }
    }
  );
}

if (!customElements.get("l-collapsible-tab")) {
  customElements.define(
    "l-collapsible-tab",
    class LTACollapsibleTab extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.init();
      }

      init() {
        this.setDefaultData();
        this.attachEvents();

        if (this.getAttribute("open") === "true") {
          this.selected = true;
          this.classList.add(this.expandedClass);
          this.setExpandedAria();
        } else {
          this.content.style.height = this.collapsedHeight;
          this.classList.add(this.collapsedClass);
          this.setCollapsedAria();
        }

        this.content.removeAttribute("hidden");
      }

      setDefaultData() {
        this.expandedClass = "is-expanded";
        this.collapsedClass = "is-collapsed";

        this.transitionendEvent = this.transitionendEventName();

        this.trigger = this.querySelector("[data-trigger]");
        this.content = this.querySelector("[data-content]");

        this.collapsedHeight = "0px";
        this.defaultElements = [
          "a",
          "button",
          "input:not(.focus-none)",
          "[data-trigger]",
        ];
        this.oneAtATime = true;

        this.dataset.oneOpen === "false" && (this.oneAtATime = false);
      }

      attachEvents() {
        this.trigger.addEventListener("click", (e) => this.toggle(e));
      }

      toggle(e) {
        e.preventDefault();

        this.selected ? this.close() : this.open();

        /* Close another tab and open only the current tab. */
        if (this.selected && this.oneAtATime) {
          const tabsContainer = this.closest("[data-collapsible-wrapper]");
          const collapsibleTabs =
            tabsContainer?.querySelectorAll("l-collapsible-tab");

          collapsibleTabs?.length &&
            collapsibleTabs.forEach((tab) => {
              tab !== this &&
                tab.selected &&
                tabsContainer !== tab &&
                tab.close();
            });
        }
      }

      open() {
        this.selected = true;
        this.expand();
        this.setAttribute("open", true);
      }

      close() {
        this.selected = false;
        this.collapse();
        this.removeAttribute("open");
      }

      expand() {
        const onTransitionEnd = ((event) => {
          if (event.target === this.content) {
            this.content.removeEventListener(
              this.transitionendEvent,
              onTransitionEnd
            );

            this.isOpen &&
              requestAnimationFrame(() => {
                this.content.style.transition = "0";
                this.content.style.height = "auto";

                requestAnimationFrame(() => {
                  this.content.style.height = null;
                  this.content.style.transition = null;
                  this.setExpandedAria();
                  this.trySetTabIndex(this.content, 0);
                });
              });
          }
        }).bind(this);

        this.content.addEventListener(this.transitionendEvent, onTransitionEnd);
        this.isOpen = true;
        this.classList.add(this.expandedClass);
        this.classList.remove(this.collapsedClass);
        this.content.style.height = this.content.scrollHeight + "px";
      }

      collapse() {
        const onTransitionEnd = ((event) => {
          if (event.target === this.content) {
            this.content.removeEventListener(
              this.transitionendEvent,
              onTransitionEnd
            );

            if (!this.isOpen) {
              this.setCollapsedAria();
              this.classList.add(this.collapsedClass);
              this.trySetTabIndex(this.content, -1);
            }
          }
        }).bind(this);

        this.content.addEventListener(this.transitionendEvent, onTransitionEnd);
        this.isOpen = false;
        this.classList.remove(this.expandedClass);

        requestAnimationFrame(() => {
          this.content.style.transition = "0";
          this.content.style.height = this.content.scrollHeight + "px";

          requestAnimationFrame(() => {
            this.content.style.transition = null;
            this.content.style.height = this.collapsedHeight;
          });
        });
      }

      destroy() {
        this.trigger &&
          this.trigger.removeEventListener("click", (e) => this.toggle(e));
        this.content && this.content.removeAttribute("aria-hidden");
        this.content && (this.content.style.height = "auto");

        this.classList.remove(this.expandedClass, this.collapsedClass);
        this.removeAttribute("open");
      }

      transitionendEventName() {
        let eventName,
          testElement = document.createElement("div"),
          eventNames = {
            transition: "transitionend",
            OTransition: "otransitionend",
            MozTransition: "transitionend",
            WebkitTransition: "webkitTransitionEnd",
          };

        for (eventName in eventNames) {
          if (
            eventNames.hasOwnProperty(eventName) &&
            testElement.style[eventName] !== false
          ) {
            return eventNames[eventName];
          }
        }
      }

      trySetTabIndex(parentElement, tabIndex) {
        const elements = parentElement.querySelectorAll(this.defaultElements);

        elements &&
          elements.forEach((e) => {
            e.setAttribute("tabindex", tabIndex);
          });
      }

      setExpandedAria() {
        this.trigger.setAttribute("aria-expanded", "true");
        this.content.setAttribute("aria-hidden", "false");
      }

      setCollapsedAria() {
        this.trigger.setAttribute("aria-expanded", "false");
        this.content.setAttribute("aria-hidden", "true");
      }
    }
  );
}

if (!customElements.get("l-block-klaviyo-link")) {
  customElements.define(
    "l-block-klaviyo-link",
    class LTAKlaviyoLink extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        // Elements
        this.subscriptionFormTriggerEl = this.querySelector(
          "[data-subscription-form-trigger]"
        );

        // Data
        const formId = this.dataset.formId;

        if (!formId) return;

        this.subscriptionFormTriggerEl.addEventListener("click", (event) => {
          event.preventDefault();

          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(["openForm", formId]);
        });
      }
    }
  );
}

if (!customElements.get("l-hulk-form")) {
  customElements.define(
    "l-hulk-form",
    class LTAHulkPopupForm extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        // Elements
        this.triggerElements = document.querySelectorAll(
          "[data-hulk-popup-form-trigger]"
        );
        this.closeBtnEl = this.querySelector("[data-close]");

        this.triggerElements.forEach((triggerElement) => {
          triggerElement.addEventListener("click", (event) => {
            event.preventDefault();

            this.classList.add("is-active");
          });
        });

        this.closeBtnEl.addEventListener("click", (event) => {
          event.preventDefault();

          this.classList.remove("is-active");
        });
      }
    }
  );
}

/************************************************************************************

* PRODUCT PAGE COMPONENTS

*************************************************************************************/
if (!customElements.get("l-pre-order-product-form")) {
  customElements.define(
    "l-pre-order-product-form",
    class LTAPreOrderButtons extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.miniCart = document.querySelector("mini-cart");
        this.preOrderBtnEls = this.querySelectorAll("[data-pre-order-button]");
        this.mainATCButtonEl = document.querySelector(
          ".product-form .product-form__submit"
        );
        this.mainATCButtonComparePriceEl = this.mainATCButtonEl?.querySelector(
          "[data-variant-compare-price]"
        );
        this.mainATCButtonPriceEl = this.mainATCButtonEl?.querySelector(
          "[data-variant-normal-price]"
        );

        this.updatePriceButtons();

        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.handleOnVariantChange.bind(this)
        );

        this.handleShopifyVariantChange = (event) => {
          if (event.detail && event.detail.variant) {
            this._currentVariant = event.detail.variant;
            this._expectedVariantId = event.detail.variant.id;
            this.updateButtonPricesImmediate(event.detail.variant);
            this.manageGloboButtons();
          } else {
            setTimeout(() => {
              const currentVariant = this._currentVariant || this.getCurrentVariant();
              if (currentVariant) {
                this.updateButtonPricesImmediate(currentVariant);
              } else {
                this.updateButtonPrices();
              }
              this.manageGloboButtons();
            }, 300);
          }
        };

        document.addEventListener(
          "variant:change",
          this.handleShopifyVariantChange
        );
        this.addToCartEvents();

        this.observer = new MutationObserver((mutations) => {
          let shouldUpdate = false;
          let globoElementsAdded = false;

          mutations.forEach((mutation) => {
            if (
              mutation.type === "childList" &&
              mutation.addedNodes.length > 0
            ) {
              mutation.addedNodes.forEach((node) => {
                if (
                  node.nodeType === 1 &&
                  (node.classList?.contains("gpo-clone-atc-button") ||
                    node.querySelector?.(".gpo-clone-atc-button"))
                ) {
                  shouldUpdate = true;
                }

                if (
                  node.nodeType === 1 &&
                  (node.querySelector?.("[data-gpo-selected]") ||
                    node.querySelector?.(
                      'input[type="radio"][gpo-data-variant-id]'
                    ) ||
                    node.matches?.("[data-gpo-selected]") ||
                    node.matches?.('input[type="radio"][gpo-data-variant-id]'))
                ) {
                  globoElementsAdded = true;
                }
              });
            }
          });

          if (shouldUpdate) {
            this.updatePriceButtons();
            this.manageGloboButtons();
          }

          if (globoElementsAdded) {
            setTimeout(() => {
              this.processPreselectedOptions();
            }, 100);
          }
        });

        this.observer.observe(document.body, {
          childList: true,
          subtree: true,
        });

        this.handleGloboVariantChange = (event) => {
          if (this.updateTimeout) {
            clearTimeout(this.updateTimeout);
          }
          this.updateTimeout = setTimeout(() => {
            const variantToUse = this._currentVariant || this.getCurrentVariant();
            if (variantToUse) {
              this.updateButtonPricesImmediate(variantToUse);
            } else {
              this.updateButtonPrices();
            }
            this.manageGloboButtons();
          }, 200);
        };

        document.addEventListener(
          "gpo:variant:changed",
          this.handleGloboVariantChange
        );

        document.addEventListener("gpo:app:loaded", () => {
          setTimeout(() => {
            this.processPreselectedOptions();
          }, 200);
        });

        document.addEventListener("gpo:options:initialized", () => {
          setTimeout(() => {
            this.processPreselectedOptions();
          }, 100);
        });

        this.setupGloboOptionsListener();

        this.storeOriginalPreOrderPrices();

        this.initializeWithRefresh();

        this.waitForGloboAppToLoad();

        this.setupCartObserver();
        this.setupCartIdObserver();

        setTimeout(() => {
          this.manageGloboButtons();
        }, 100);
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber && this.variantChangeUnsubscriber();
        this.observer && this.observer.disconnect();

        if (this.updateTimeout) {
          clearTimeout(this.updateTimeout);
        }
        if (this.variantUpdateTimeout) {
          clearTimeout(this.variantUpdateTimeout);
        }

        if (this.handleGloboVariantChange) {
          document.removeEventListener(
            "gpo:variant:changed",
            this.handleGloboVariantChange
          );
        }
        if (this.handleGloboClick) {
          document.removeEventListener("click", this.handleGloboClick);
        }
        if (this.handleGloboInputChange) {
          document.removeEventListener("change", this.handleGloboInputChange);
        }
        if (this.handleGloboOptionDeselect) {
          document.removeEventListener("click", this.handleGloboOptionDeselect);
        }
        if (this.handleShopifyVariantChange) {
          document.removeEventListener(
            "variant:change",
            this.handleShopifyVariantChange
          );
        }
      }

      updatePriceButtons() {
        this.allPriceButtons = document.querySelectorAll(
          ".product-form__submit, .gpo-clone-atc-button, [data-variant-compare-price], [data-variant-normal-price]"
        );

        this.mainFormButton = document.querySelector(".product-form__submit");
      }

      manageGloboButtons() {
        const originalButton = document.querySelector(
          ".gpo-original-atc-button"
        );
        const cloneButton = document.querySelector(".gpo-clone-atc-button");

        if (originalButton && cloneButton) {
          originalButton.classList.add("l-hidden");
          cloneButton.classList.remove("l-hidden");
        } else if (originalButton && !cloneButton) {
          originalButton.classList.remove("l-hidden");
        } else if (!originalButton && cloneButton) {
          cloneButton.classList.remove("l-hidden");
        }
      }

      storeOriginalPreOrderPrices() {
        this.preOrderBasePrices = new Map();

        this.preOrderBtnEls.forEach((preOrderBtn, index) => {
          const titleElement = preOrderBtn.querySelector(
            ".l-product-preorder-button__title"
          );

          if (titleElement) {
            const priceElements = titleElement.querySelectorAll("strong");

            priceElements.forEach((priceElement, priceIndex) => {
              if (
                priceElement &&
                !priceElement.textContent.includes("pre-order") &&
                !priceElement.textContent.includes("save") &&
                !priceElement.textContent.includes("%")
              ) {
                const priceText = priceElement.textContent.trim();
                const priceMatch = priceText.match(/[\$£€¥]?([\d,]+\.?\d*)/);

                if (priceMatch) {
                  const originalPrice = parseFloat(
                    priceMatch[1].replace(/,/g, "")
                  );
                  const preOrderVariantId = preOrderBtn.dataset.addToCartId;

                  this.preOrderBasePrices.set(preOrderVariantId, originalPrice);
                } else {
                }
              } else {
              }
            });
          }
        });
      }

      waitForGloboAppToLoad() {
        const checkGloboLoaded = () => {
          const globoElements = document.querySelectorAll(
            "[data-gpo-selected], input[type='radio'][gpo-data-variant-id]"
          );
          const hasGloboElements = globoElements.length > 0;

          if (hasGloboElements) {
            this.processPreselectedOptions();
            return true;
          }

          return false;
        };

        if (checkGloboLoaded()) {
          return;
        }

        let attempts = 0;
        const maxAttempts = 20;

        const interval = setInterval(() => {
          attempts++;

          if (checkGloboLoaded()) {
            clearInterval(interval);
            return;
          }

          if (attempts >= maxAttempts) {
            clearInterval(interval);
            this.processPreselectedOptions();
          }
        }, 500);
      }

      processPreselectedOptions() {
        const selectedOptions = document.querySelectorAll(
          '.gpo-swatches input[type="radio"]:checked[gpo-data-variant-id], .gpo-element input[type="radio"]:checked[gpo-data-variant-id], input[type="radio"]:checked[gpo-data-variant-id]'
        );

        if (selectedOptions.length > 0) {
          selectedOptions.forEach((option, index) => {
            const variantId = option.getAttribute("gpo-data-variant-id");
            const optionValue = option.value;
          });

          const currentVariant = this.getCurrentVariant();
          if (currentVariant) {
            this.updateButtonPricesImmediate(currentVariant);
          } else {
            this.updateButtonPrices();
          }
        } else {
        }
      }

      initializeWithRefresh() {
        this.checkForPreselectedOptions();

        setTimeout(() => {
          this.checkForPreselectedOptions();
        }, 100);

        setTimeout(() => {
          this.checkForPreselectedOptions();
        }, 500);

        setTimeout(() => {
          this.checkForPreselectedOptions();
        }, 1000);
      }

      checkForPreselectedOptions() {
        const preselectedOptions = document.querySelectorAll(
          'input[type="radio"]:checked[gpo-data-variant-id], .gpo-swatches input[type="radio"]:checked[gpo-data-variant-id], .gpo-element input[type="radio"]:checked[gpo-data-variant-id]'
        );

        if (preselectedOptions.length > 0) {
          preselectedOptions.forEach((option, index) => {
            const variantId = option.getAttribute("gpo-data-variant-id");
            const optionValue = option.value;
          });

          const currentVariant = this.getCurrentVariant();
          if (currentVariant) {
            this.updateButtonPricesImmediate(currentVariant);
          } else {
            this.updateButtonPrices();
          }
        } else {
          const currentVariant = this.getCurrentVariant();
          if (currentVariant) {
            this.updateButtonPricesImmediate(currentVariant);
          } else {
            this.updateButtonPrices();
          }
        }
      }

      getCurrentVariant() {
        const variantSelects = document.querySelector("variant-selects");
        if (variantSelects && variantSelects.currentVariant) {
          return variantSelects.currentVariant;
        }

        const productForm = document.querySelector(
          'form[data-type="add-to-cart-form"]'
        );
        if (productForm) {
          const variantInput = productForm.querySelector('input[name="id"]');
          if (variantInput && variantInput.value) {
            return {
              id: parseInt(variantInput.value),
              price: 0,
              compare_at_price: 0,
            };
          }
        }

        return null;
      }

      updateButtonPricesImmediate(variant) {
        // Check if this is a stale update from an old variant
        if (this._expectedVariantId && variant?.id && this._expectedVariantId !== variant.id) {
          return;
        }

        // Only prevent duplicate calls within a very short timeframe
        const now = Date.now();
        if (this._lastUpdateTime && now - this._lastUpdateTime < 50) {
          return;
        }
        this._lastUpdateTime = now;

        if (!variant) {
          return;
        }

        let basePrice = variant.price / 100;

        let optionsTotal = 0;

        const processedOptions = new Set();

        const selectedOptions = document.querySelectorAll(
          '.gpo-swatches input[type="radio"]:checked[gpo-data-variant-id], .gpo-element input[type="radio"]:checked[gpo-data-variant-id], input[type="radio"]:checked[gpo-data-variant-id]'
        );

        if (selectedOptions.length === 0) {
          const formattedPrice = theme.Currency.formatMoney(basePrice * 100);

          if (this.mainFormButton) {
            const mainNormalPriceEl = this.mainFormButton.querySelector(
              "[data-variant-normal-price]"
            );
            if (mainNormalPriceEl) {
              mainNormalPriceEl.innerHTML = formattedPrice;
            }

            // Update actual text content in the button
            const titleElement = this.mainFormButton.querySelector(
              ".l-product-preorder-button__title, .l-flex, .l-flex-col"
            );
            if (titleElement) {
              const priceElements = titleElement.querySelectorAll("strong");
              priceElements.forEach((priceEl) => {
                const text = priceEl.textContent.trim();
                if (
                  text.includes("$") &&
                  /\d/.test(text) &&
                  priceEl.tagName === "STRONG" &&
                  !text.includes("pre-order") &&
                  !text.includes("save") &&
                  !text.includes("%") &&
                  !priceEl.hasAttribute("data-amount")
                ) {
                  priceEl.textContent = formattedPrice;
                }
              });

              // Handle case where price is directly in the title element text (not in strong tags)
              // Skip if title has structured elements (amount spans, strong tags with data attributes)
              const hasStructuredContent = titleElement.querySelector("[data-amount]");
              if (!hasStructuredContent) {
                const titleText = titleElement.textContent.trim();
                if (titleText.includes("$") && /\d/.test(titleText) && !titleText.includes("pre-order")) {
                  const priceRegex = /\$[\d,]+\.?\d*/g;
                  const newText = titleText.replace(priceRegex, formattedPrice);
                  titleElement.textContent = newText;
                }
              }

              // Update compare price and save percentage for simple case
              if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                const comparePrice = variant.compare_at_price / 100;
                const formattedComparePrice = theme.Currency.formatMoney(
                  comparePrice * 100
                );

                const compareElements = titleElement.querySelectorAll("s");
                compareElements.forEach((compareEl) => {
                  const text = compareEl.textContent.trim();
                  if (text.includes("$") && /\d/.test(text)) {
                    compareEl.textContent = formattedComparePrice;
                    compareEl.style.display = "inline";
                  }
                });

                // Update save percentage
                const reductionPrice = comparePrice - basePrice;
                // Use Math.round for more accurate percentage calculation
                const salePercentage = Math.round((reductionPrice / comparePrice) * 100);
                const formattedAmount = theme.Currency.formatMoney(reductionPrice * 100);

                console.log('Save percentage calculation (simple):', {
                  comparePrice,
                  basePrice,
                  reductionPrice,
                  salePercentage,
                  variantId: variant.id
                });

                const percentageElements = titleElement.querySelectorAll("strong");
                percentageElements.forEach((percentageEl) => {
                  const text = percentageEl.textContent.trim();
                  if (text.includes("save") && text.includes("%")) {
                    const innerAmount = percentageEl.querySelector("[data-amount]");
                    if (innerAmount) {
                      innerAmount.textContent = formattedAmount;
                      percentageEl.childNodes.forEach((node) => {
                        if (node.nodeType === 3 && node.textContent.includes("save")) {
                          node.textContent = `(save ${salePercentage}%) `;
                        }
                      });
                    } else {
                      percentageEl.textContent = `(save ${salePercentage}%)`;
                    }
                    percentageEl.style.display = "inline";
                  }
                });

                // Update amount elements outside strong
                titleElement.querySelectorAll("[data-amount]").forEach((amountEl) => {
                  amountEl.textContent = formattedAmount;
                  amountEl.style.display = "inline";
                });
              } else {
                // Hide compare price and save percentage when no discount
                const compareElements = titleElement.querySelectorAll("s");
                compareElements.forEach((compareEl) => {
                  compareEl.style.display = "none";
                });

                const percentageElements = titleElement.querySelectorAll("strong");
                percentageElements.forEach((percentageEl) => {
                  const text = percentageEl.textContent.trim();
                  if (text.includes("save") && text.includes("%")) {
                    percentageEl.style.display = "none";
                  }
                });

                // Hide amount when no discount
                titleElement.querySelectorAll("[data-amount]").forEach((amountEl) => {
                  amountEl.style.display = "none";
                });
              }
            }
          }

          this.allPriceButtons.forEach((button) => {
            const normalPriceEl = button.querySelector(
              "[data-variant-normal-price]"
            );
            if (normalPriceEl) {
              normalPriceEl.innerHTML = formattedPrice;
            }
          });

          const globoCloneButtons = document.querySelectorAll(
            ".gpo-clone-atc-button [data-variant-normal-price]"
          );
          globoCloneButtons.forEach((priceEl) => {
            priceEl.innerHTML = formattedPrice;
          });

          const preOrderButtons = document.querySelectorAll(
            "[data-pre-order-button]"
          );

          preOrderButtons.forEach((preOrderBtn, index) => {
            if (preOrderBtn.classList.contains("l-hidden")) {
              return;
            }

            const titleElement = preOrderBtn.querySelector(
              ".l-product-preorder-button__title"
            );

            if (titleElement) {
              const preOrderVariantId = preOrderBtn.dataset.addToCartId;
              const preOrderBasePrice =
                this.preOrderBasePrices.get(preOrderVariantId) || 0;

              if (preOrderBasePrice > 0) {
                const formattedPreOrderPrice = theme.Currency.formatMoney(
                  preOrderBasePrice * 100
                );

                const priceElements = titleElement.querySelectorAll("strong");
                priceElements.forEach((priceEl) => {
                  const text = priceEl.textContent.trim();
                  if (
                    text.includes("$") &&
                    /\d/.test(text) &&
                    priceEl.tagName === "STRONG" &&
                    !text.includes("pre-order") &&
                    !text.includes("save") &&
                    !text.includes("%")
                  ) {
                    priceEl.textContent = formattedPreOrderPrice;
                  }
                });
              }
            }
          });

          return;
        }

        selectedOptions.forEach((option) => {
          const variantId = option.getAttribute("gpo-data-variant-id");
          const optionValue = option.value;

          const optionKey = `${variantId}-${optionValue}`;

          if (processedOptions.has(optionKey)) {
            return;
          }

          if (variantId === variant.id.toString()) {
            return;
          }

          processedOptions.add(optionKey);

          if (variantId) {
            let optionPrice = 0;

            const optionContainer =
              option.closest(".gpo-swatches") || option.closest(".gpo-element");

            if (optionContainer) {
              const label = optionContainer.querySelector(".gpo-label .addOn");
              if (label) {
                const priceText = label.textContent.trim();
                const priceMatch = priceText.match(/[\d,]+\.?\d*/);
                if (priceMatch) {
                  optionPrice = parseFloat(priceMatch[0].replace(/,/g, ""));
                }
              }

              if (optionPrice === 0) {
                const tooltip = optionContainer.querySelector(
                  ".gpo-tooltip .addOn"
                );
                if (tooltip) {
                  const priceText = tooltip.textContent.trim();
                  const priceMatch = priceText.match(/[\d,]+\.?\d*/);
                  if (priceMatch) {
                    optionPrice = parseFloat(priceMatch[0].replace(/,/g, ""));
                  }
                }
              }

              if (optionPrice === 0) {
                const priceSelectors = [
                  ".gpo-option-price",
                  ".price",
                  "[data-price]",
                  ".gpo-price",
                  ".option-price",
                  ".variant-price",
                  'span[class*="price"]',
                  'div[class*="price"]',
                  ".addOn",
                ];

                for (const selector of priceSelectors) {
                  const priceElement = optionContainer.querySelector(selector);
                  if (priceElement) {
                    const priceText = priceElement.textContent.trim();
                    const priceMatch = priceText.match(/[\d,]+\.?\d*/);
                    if (priceMatch) {
                      optionPrice = parseFloat(priceMatch[0].replace(/,/g, ""));
                      break;
                    }
                  }
                }
              }
            }

            if (optionPrice > 0) {
              optionsTotal += optionPrice;
            }
          }
        });

        const totalPrice = basePrice + optionsTotal;

        if (totalPrice > 0) {
          const formattedPrice = theme.Currency.formatMoney(totalPrice * 100);

          if (this.mainFormButton) {
            const mainNormalPriceEl = this.mainFormButton.querySelector(
              "[data-variant-normal-price]"
            );
            const mainComparePriceEl = this.mainFormButton.querySelector(
              "[data-variant-compare-price]"
            );

            if (mainNormalPriceEl) {
              mainNormalPriceEl.innerHTML = formattedPrice;
            }

            if (mainComparePriceEl && variant.compare_at_price) {
              const comparePrice = variant.compare_at_price / 100;
              const formattedComparePrice = theme.Currency.formatMoney(
                comparePrice * 100
              );
              mainComparePriceEl.innerHTML = formattedComparePrice;
              mainComparePriceEl.classList.toggle(
                "l-hidden",
                !variant.compare_at_price ||
                variant.compare_at_price <= variant.price
              );
            }

            // Update actual text content in the button
            const titleElement = this.mainFormButton.querySelector(
              ".l-product-preorder-button__title, .l-flex, .l-flex-col"
            );
            if (titleElement) {
              // Update normal price in text
              const priceElements = titleElement.querySelectorAll("strong");
              priceElements.forEach((priceEl) => {
                const text = priceEl.textContent.trim();
                if (
                  text.includes("$") &&
                  /\d/.test(text) &&
                  priceEl.tagName === "STRONG" &&
                  !text.includes("pre-order") &&
                  !text.includes("save") &&
                  !text.includes("%") &&
                  !text.includes("<s>") &&
                  !priceEl.hasAttribute("data-amount")
                ) {
                  priceEl.textContent = formattedPrice;
                }
              });

              // Update compare price in text
              if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                const comparePrice = variant.compare_at_price / 100;
                const formattedComparePrice = theme.Currency.formatMoney(
                  comparePrice * 100
                );

                const compareElements = titleElement.querySelectorAll("s");
                compareElements.forEach((compareEl) => {
                  const text = compareEl.textContent.trim();
                  if (text.includes("$") && /\d/.test(text)) {
                    compareEl.textContent = formattedComparePrice;
                  }
                });

                // Update save percentage
                // Calculate percentage based on base variant price only, not including GPO options
                // This keeps the discount percentage consistent regardless of selected options
                const reductionPrice = comparePrice - basePrice;
                // Use Math.round for more accurate percentage calculation
                const salePercentage = Math.round((reductionPrice / comparePrice) * 100);
                const formattedAmount = theme.Currency.formatMoney(reductionPrice * 100);

                console.log('Save percentage calculation:', {
                  comparePrice,
                  basePrice,
                  totalPrice,
                  reductionPrice,
                  salePercentage,
                  variantId: variant.id
                });

                const percentageElements = titleElement.querySelectorAll("strong");
                percentageElements.forEach((percentageEl) => {
                  const text = percentageEl.textContent.trim();
                  if (text.includes("save") && text.includes("%")) {
                    const innerAmount = percentageEl.querySelector("[data-amount]");
                    if (innerAmount) {
                      innerAmount.textContent = formattedAmount;
                      percentageEl.childNodes.forEach((node) => {
                        if (node.nodeType === 3 && node.textContent.includes("save")) {
                          node.textContent = `(save ${salePercentage}%) `;
                        }
                      });
                    } else {
                      percentageEl.textContent = `(save ${salePercentage}%)`;
                    }
                  }
                });

                // Update amount elements outside strong
                titleElement.querySelectorAll("[data-amount]").forEach((amountEl) => {
                  amountEl.textContent = formattedAmount;
                  amountEl.style.display = "inline";
                });
              } else {
                // Hide compare price and save percentage when no discount
                const compareElements = titleElement.querySelectorAll("s");
                compareElements.forEach((compareEl) => {
                  compareEl.style.display = "none";
                });

                const percentageElements = titleElement.querySelectorAll("strong");
                percentageElements.forEach((percentageEl) => {
                  const text = percentageEl.textContent.trim();
                  if (text.includes("save") && text.includes("%")) {
                    percentageEl.style.display = "none";
                  }
                });

                // Hide amount when no discount
                titleElement.querySelectorAll("[data-amount]").forEach((amountEl) => {
                  amountEl.style.display = "none";
                });
              }
            }

            // Debug log for testing
            const salePercentage = variant.compare_at_price && variant.compare_at_price > variant.price
              ? Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100)
              : 0;
            console.log('Updated main button prices:', {
              normalPrice: formattedPrice,
              comparePrice: variant.compare_at_price ? theme.Currency.formatMoney(variant.compare_at_price) : 'No compare price',
              salePercentage: salePercentage > 0 ? `${salePercentage}%` : 'No discount',
              variantId: variant.id
            });
          }

          this.allPriceButtons.forEach((button) => {
            const normalPriceEl = button.querySelector(
              "[data-variant-normal-price]"
            );
            const comparePriceEl = button.querySelector(
              "[data-variant-compare-price]"
            );

            if (normalPriceEl) {
              normalPriceEl.innerHTML = formattedPrice;
            }

            if (comparePriceEl && variant.compare_at_price) {
              const comparePrice = variant.compare_at_price / 100;
              const formattedComparePrice = theme.Currency.formatMoney(
                comparePrice * 100
              );
              comparePriceEl.innerHTML = formattedComparePrice;
              comparePriceEl.classList.toggle(
                "l-hidden",
                !variant.compare_at_price ||
                variant.compare_at_price <= variant.price
              );
            }
          });

          const globoCloneButtons = document.querySelectorAll(
            ".gpo-clone-atc-button [data-variant-normal-price]"
          );
          globoCloneButtons.forEach((priceEl) => {
            priceEl.innerHTML = formattedPrice;
          });

          const preOrderButtons = document.querySelectorAll(
            "[data-pre-order-button]"
          );

          preOrderButtons.forEach((preOrderBtn, index) => {
            if (preOrderBtn.classList.contains("l-hidden")) {
              return;
            }

            const titleElement = preOrderBtn.querySelector(
              ".l-product-preorder-button__title"
            );
            if (titleElement) {
              const preOrderVariantId = preOrderBtn.dataset.addToCartId;

              let preOrderBasePrice =
                this.preOrderBasePrices.get(preOrderVariantId) || 0;

              if (preOrderBasePrice === 0) {
                const currentPriceElement =
                  titleElement.querySelector("strong");
                if (
                  currentPriceElement &&
                  !currentPriceElement.textContent.includes("pre-order")
                ) {
                  const priceText = currentPriceElement.textContent.trim();
                  const priceMatch = priceText.match(/[\$£€¥]?([\d,]+\.?\d*)/);
                  if (priceMatch) {
                    preOrderBasePrice = parseFloat(
                      priceMatch[1].replace(/,/g, "")
                    );
                  }
                }

                if (preOrderBasePrice === 0) {
                  preOrderBasePrice = basePrice;
                }
              } else {
              }

              const preOrderPrice = preOrderBasePrice + optionsTotal;

              const formattedPreOrderPrice = theme.Currency.formatMoney(
                preOrderPrice * 100
              );

              const priceElements = titleElement.querySelectorAll("strong, s");

              priceElements.forEach((priceEl, priceIndex) => {
                const text = priceEl.textContent.trim();

                if (text.includes("$") && /\d/.test(text)) {
                  if (priceEl.tagName === "S" && variant.compare_at_price) {
                    const comparePrice = variant.compare_at_price / 100;
                    const formattedComparePrice = theme.Currency.formatMoney(
                      comparePrice * 100
                    );
                    priceEl.textContent = formattedComparePrice;
                  } else if (
                    priceEl.tagName === "STRONG" &&
                    !text.includes("pre-order") &&
                    !text.includes("save") &&
                    !text.includes("%")
                  ) {
                    priceEl.textContent = formattedPreOrderPrice;
                  } else {
                  }
                }
              });
            }
          });
        }
      }

      handleOnVariantChange({ data }) {
        const variant = data.variant;
        const variantId = `${data.variant.id}`;

        this._currentVariant = variant;
        this._expectedVariantId = variant.id;

        this.preOrderBtnEls.forEach((preOrderBtnEl) => {
          const currentVariantId = preOrderBtnEl.dataset.variantId;

          preOrderBtnEl.classList.toggle(
            "l-hidden",
            variantId != currentVariantId
          );
        });

        if (this.variantUpdateTimeout) {
          clearTimeout(this.variantUpdateTimeout);
        }
        this.variantUpdateTimeout = setTimeout(() => {
          this.updateButtonPricesImmediate(variant);
        }, 50);
      }

      getGloboOptionName(element) {
        let name =
          element.getAttribute("name") ||
          element.getAttribute("data-name") ||
          element.getAttribute("data-option-name");

        if (!name) {
          const label =
            element.closest("label") ||
            element.parentElement?.querySelector("label") ||
            element.closest("[data-option-label]");

          if (label) {
            name =
              label.textContent?.trim() ||
              label.getAttribute("data-option-label") ||
              label.getAttribute("aria-label");
          }
        }

        if (name) {
          name = name.replace(/[\[\]]/g, "").trim();
        }

        return name;
      }

      handleErrorMessage(errorMessage = false) {
        const errorWrapper = document.querySelector(
          ".product-form__error-message-wrapper"
        );
        const errorElement = errorWrapper?.querySelector(
          ".product-form__error-message"
        );

        if (errorWrapper && errorElement) {
          errorWrapper.toggleAttribute("hidden", !errorMessage);
          if (errorMessage) {
            errorElement.textContent = errorMessage;
          }
        } else if (errorMessage) {
          alert(errorMessage);
        }
      }

      setupGloboOptionsListener() {
        const globoOptionsObserver = new MutationObserver((mutations) => {
          let shouldUpdate = false;
          mutations.forEach((mutation) => {
            if (
              mutation.type === "attributes" &&
              mutation.attributeName === "data-gpo-selected"
            ) {
              shouldUpdate = true;
            }

            if (
              mutation.type === "attributes" &&
              mutation.attributeName === "checked"
            ) {
              shouldUpdate = true;
            }
          });

          if (shouldUpdate) {
            setTimeout(() => {
              const variantToUse = this._currentVariant || this.getCurrentVariant();
              if (variantToUse) {
                this.updateButtonPricesImmediate(variantToUse);
              } else {
                this.updateButtonPrices();
              }
            }, 100);
          }
        });

        const globoElements = document.querySelectorAll("[data-gpo-selected]");
        globoElements.forEach((element) => {
          globoOptionsObserver.observe(element, {
            attributes: true,
            attributeFilter: ["data-gpo-selected"],
          });
        });

        const globoInputs = document.querySelectorAll(
          'input[type="radio"][gpo-data-variant-id]'
        );
        globoInputs.forEach((input) => {
          globoOptionsObserver.observe(input, {
            attributes: true,
            attributeFilter: ["checked"],
          });
        });

        this.handleGloboClick = (event) => {
          if (
            event.target.closest("[data-gpo-selected]") ||
            event.target.closest(".gpo-option") ||
            event.target.closest("[data-gpo-option]")
          ) {
            if (this.updateTimeout) {
              clearTimeout(this.updateTimeout);
            }
            this.updateTimeout = setTimeout(() => {
              const variantToUse = this._currentVariant || this.getCurrentVariant();
              if (variantToUse) {
                this.updateButtonPricesImmediate(variantToUse);
              } else {
                this.updateButtonPrices();
              }
            }, 200);
          }
        };

        document.addEventListener("click", this.handleGloboClick);

        this.handleGloboInputChange = (event) => {
          if (
            event.target.matches('input[type="radio"][gpo-data-variant-id]')
          ) {
            const isChecked = event.target.checked;
            const optionValue = event.target.value;
            const variantId = event.target.getAttribute("gpo-data-variant-id");

            if (this.updateTimeout) {
              clearTimeout(this.updateTimeout);
            }
            this.updateTimeout = setTimeout(() => {
              const variantToUse = this._currentVariant || this.getCurrentVariant();
              if (variantToUse) {
                this.updateButtonPricesImmediate(variantToUse);
              } else {
                this.updateButtonPrices();
              }
            }, 200);
          }
        };

        document.addEventListener("change", this.handleGloboInputChange);

        this.handleGloboOptionDeselect = (event) => {
          if (
            event.target.matches('input[type="radio"][gpo-data-variant-id]') &&
            event.target.checked === false
          ) {
            if (this.updateTimeout) {
              clearTimeout(this.updateTimeout);
            }
            this.updateTimeout = setTimeout(() => {
              const variantToUse = this._currentVariant || this.getCurrentVariant();
              if (variantToUse) {
                this.updateButtonPricesImmediate(variantToUse);
              } else {
                this.updateButtonPrices();
              }
            }, 100);
          }
        };

        document.addEventListener("click", this.handleGloboOptionDeselect);

        if (document.readyState === "loading") {
          document.addEventListener("DOMContentLoaded", () => {
            setTimeout(() => {
              const variantToUse = this._currentVariant || this.getCurrentVariant();
              if (variantToUse) {
                this.updateButtonPricesImmediate(variantToUse);
              } else {
                this.updateButtonPrices();
              }
            }, 500);
          });
        } else {
          setTimeout(() => {
            const variantToUse = this._currentVariant || this.getCurrentVariant();
            if (variantToUse) {
              this.updateButtonPricesImmediate(variantToUse);
            } else {
              this.updateButtonPrices();
            }
          }, 500);
        }
      }

      updateButtonPrices() {
        let basePrice = 0;

        if (this.mainFormButton) {
          const mainPriceEl = this.mainFormButton.querySelector(
            "[data-variant-normal-price]"
          );
          if (mainPriceEl) {
            const priceText = mainPriceEl.textContent.trim();
            const priceMatch = priceText.match(/[\d,]+\.?\d*/);
            if (priceMatch) {
              basePrice = parseFloat(priceMatch[0].replace(/,/g, ""));
            }
          }
        }

        if (basePrice === 0) {
          const priceSelectors = [
            ".gp-product-price .gp-money",
            ".price-item--regular price-money bdi",
            ".price-item--sale price-money bdi",
            ".price__regular .price-item--regular",
            ".price__current .price-item--current",
            ".price__regular .price-item--regular",
            ".price__sale .price-item--sale",
            ".product__price .price",
            ".product-price .price",
            ".product__info .price",
            ".product-info .price",
          ];

          for (const selector of priceSelectors) {
            const priceElement = document.querySelector(selector);
            if (priceElement && priceElement.textContent.trim()) {
              const priceText = priceElement.textContent.trim();
              const priceMatch = priceText.match(/[\d,]+\.?\d*/);
              if (priceMatch) {
                basePrice = parseFloat(priceMatch[0].replace(/,/g, ""));
                break;
              }
            }
          }
        }

        if (basePrice === 0) {
          const variantSelects = document.querySelector("variant-selects");
          if (variantSelects && variantSelects.currentVariant) {
            basePrice = variantSelects.currentVariant.price / 100;
          } else {
            setTimeout(() => {
              this.updateButtonPrices();
            }, 200);
            return;
          }
        }

        let optionsTotal = 0;
        const selectedOptions = document.querySelectorAll(
          'input[type="radio"]:checked[gpo-data-variant-id]'
        );

        selectedOptions.forEach((option) => {
          const variantId = option.getAttribute("gpo-data-variant-id");
          if (variantId) {
            let optionPrice = 0;

            const label = option
              .closest(".gpo-element")
              .querySelector(".gpo-label .addOn");
            if (label) {
              const priceText = label.textContent.trim();
              const priceMatch = priceText.match(/[\d,]+\.?\d*/);
              if (priceMatch) {
                optionPrice = parseFloat(priceMatch[0].replace(/,/g, ""));
              }
            }

            if (optionPrice === 0) {
              const tooltip = option
                .closest(".gpo-swatches")
                .querySelector(".gpo-tooltip .addOn");
              if (tooltip) {
                const priceText = tooltip.textContent.trim();
                const priceMatch = priceText.match(/[\d,]+\.?\d*/);
                if (priceMatch) {
                  optionPrice = parseFloat(priceMatch[0].replace(/,/g, ""));
                }
              }
            }

            if (optionPrice === 0) {
              const optionContainer = option.closest(".gpo-swatches");
              if (optionContainer) {
                const priceSelectors = [
                  ".gpo-option-price",
                  ".price",
                  "[data-price]",
                  ".gpo-price",
                  ".option-price",
                  ".variant-price",
                  'span[class*="price"]',
                  'div[class*="price"]',
                  ".addOn",
                ];

                for (const selector of priceSelectors) {
                  const priceElement = optionContainer.querySelector(selector);
                  if (priceElement) {
                    const priceText = priceElement.textContent.trim();
                    const priceMatch = priceText.match(/[\d,]+\.?\d*/);
                    if (priceMatch) {
                      optionPrice = parseFloat(priceMatch[0].replace(/,/g, ""));
                      break;
                    }
                  }
                }
              }
            }

            optionsTotal += optionPrice;
          }
        });

        const totalPrice = basePrice + optionsTotal;

        if (totalPrice > 0) {
          const formattedPrice = theme.Currency.formatMoney(totalPrice * 100);

          if (this.mainFormButton) {
            const mainNormalPriceEl = this.mainFormButton.querySelector(
              "[data-variant-normal-price]"
            );
            if (mainNormalPriceEl) {
              mainNormalPriceEl.innerHTML = formattedPrice;
            }
          }

          this.allPriceButtons.forEach((button) => {
            const normalPriceEl = button.querySelector(
              "[data-variant-normal-price]"
            );
            if (normalPriceEl) {
              normalPriceEl.innerHTML = formattedPrice;
            }
          });

          const globoCloneButtons = document.querySelectorAll(
            ".gpo-clone-atc-button [data-variant-normal-price]"
          );
          globoCloneButtons.forEach((priceEl) => {
            priceEl.innerHTML = formattedPrice;
          });
        }
      }

      validateRequiredOptions() {
        const missingOptions = [];

        const mainAddToCartButton = document.querySelector(
          ".product-form__submit"
        );

        const allGloboGroups = document.querySelectorAll(
          ".gpo-swatches, .gpo-element"
        );

        allGloboGroups.forEach((group, index) => {
          const groupName =
            group.getAttribute("data-name") ||
            group.getAttribute("data-option-name") ||
            group.getAttribute("name") ||
            `Grupo ${index + 1}`;

          const options = group.querySelectorAll('input[type="radio"]');

          if (options.length > 0) {
            const selectedOption = group.querySelector(
              'input[type="radio"]:checked'
            );

            if (!selectedOption) {
              const hasRequiredAttribute =
                group.hasAttribute("required") ||
                group.hasAttribute("data-required") ||
                group.hasAttribute("data-gpo-required") ||
                group.hasAttribute("data-gpo-required-field");
              const hasRequiredClass =
                group.classList.contains("required") ||
                group.classList.contains("gpo-required") ||
                group.classList.contains("gpo-required-field") ||
                group.classList.contains("gpo-error") ||
                group.classList.contains("gpo-invalid");

              const hasErrorElements = group.querySelector(
                ".gpo-error, .gpo-invalid, .gpo-required-message, [data-gpo-error]"
              );

              const isMainButtonDisabled =
                mainAddToCartButton &&
                mainAddToCartButton.hasAttribute("aria-disabled");

              if (
                isMainButtonDisabled ||
                hasRequiredAttribute ||
                hasRequiredClass ||
                hasErrorElements
              ) {
                if (!missingOptions.includes(groupName)) {
                  missingOptions.push(groupName);
                }
              }
            }
          }
        });

        const globoErrorMessages = document.querySelectorAll(
          ".gpo-error-message, .gpo-required-message, .gpo-validation-error, [data-gpo-error-message]"
        );

        if (globoErrorMessages.length > 0) {
          globoErrorMessages.forEach((errorMsg, index) => {
            const errorText = errorMsg.textContent.trim();

            if (
              errorText.toLowerCase().includes("obrigatório") ||
              errorText.toLowerCase().includes("required") ||
              errorText.toLowerCase().includes("selecione") ||
              errorText.toLowerCase().includes("select")
            ) {
              const fieldName =
                errorMsg.getAttribute("data-field-name") ||
                errorMsg
                  .closest(".gpo-swatches, .gpo-element")
                  ?.getAttribute("data-name") ||
                "Campo obrigatório";

              if (!missingOptions.includes(fieldName)) {
                missingOptions.push(fieldName);
              }
            }
          });
        }

        if (
          mainAddToCartButton &&
          mainAddToCartButton.hasAttribute("aria-disabled") &&
          missingOptions.length === 0
        ) {
          missingOptions.push("Opções obrigatórias");
        }

        if (missingOptions.length > 0) {
          return {
            isValid: false,
            missingOptions: missingOptions,
          };
        }

        return {
          isValid: true,
          missingOptions: [],
        };
      }

      addToCartEvents() {
        this.preOrderBtnEls.forEach((preOrderBtnEl) => {
          preOrderBtnEl.addEventListener("click", (event) => {
            event.preventDefault();

            const validation = this.validateRequiredOptions();

            if (!validation.isValid) {
              const missingOptionsText = validation.missingOptions.join(", ");
              const errorMessage = `Por favor, selecione as opções obrigatórias: ${missingOptionsText}`;
              this.handleErrorMessage(errorMessage);
              return;
            }

            const preOrderVariantId = preOrderBtnEl.dataset.addToCartId;

            if (!preOrderVariantId) {
              this.handleErrorMessage("ID do produto não encontrado");
              return;
            }

            preOrderBtnEl.setAttribute("aria-disabled", true);
            preOrderBtnEl.classList.add("loading");

            const config = fetchConfig("javascript");
            config.headers["X-Requested-With"] = "XMLHttpRequest";
            delete config.headers["Content-Type"];

            const formData = new FormData();

            formData.append("quantity", 1);
            formData.append("id", preOrderVariantId);

            let preorderMessage = "";

            const preOrderForm = document.querySelector(
              "l-pre-order-product-form"
            );
            if (preOrderForm && preOrderForm.dataset.message) {
              preorderMessage = preOrderForm.dataset.message;
            }

            const existingForm = document.querySelector(
              'form[data-type="add-to-cart-form"]'
            );

            const additionalProducts = [];

            if (existingForm) {
              const formFormData = new FormData(existingForm);

              for (let [key, value] of formFormData.entries()) {
                if (key === "id") continue;

                if (key === "quantity") {
                  formData.append(key, value);
                }

                if (key.startsWith("properties[")) {
                  const propertyName = key
                    .replace("properties[", "")
                    .replace("]", "");
                  formData.append(propertyName, value);
                }
              }

              document
                .querySelectorAll('input[type="radio"]:checked')
                .forEach((radio) => {
                  const variantId = radio.getAttribute("gpo-data-variant-id");
                  if (variantId) {
                    const productId = parseInt(variantId);
                    if (!isNaN(productId) && productId > 0) {
                      additionalProducts.push({
                        id: productId,
                        quantity: 1,
                      });
                    }
                  }
                });
            }

            if (additionalProducts.length > 0) {
              const items = [
                ...additionalProducts,
                {
                  id: parseInt(preOrderVariantId),
                  quantity: 1,
                  properties: {
                    ...Object.fromEntries(formData.entries()),
                    _pre_order_id: preOrderVariantId,
                  },
                },
              ];

              const payload = {
                items: items,
              };

              if (this.miniCart) {
                payload.sections = this.miniCart
                  .getSectionsToRender()
                  .map((section) => section.id);
              }
              payload.sections_url = window.location.pathname;

              config.body = JSON.stringify(payload);
              config.headers["Content-Type"] = "application/json";

              fetch(`${theme.routes.cart_add_url}.js`, config)
                .then((response) => {
                  if (!response.ok) {
                    return response.text().then((text) => {
                      throw new Error(`HTTP ${response.status}: ${text}`);
                    });
                  }

                  return response.json();
                })
                .then((response) => {
                  if (response.status) {
                    publish(PUB_SUB_EVENTS.cartError, {
                      source: "product-form",
                      productVariantId: preOrderVariantId,
                      errors: response.errors || response.description,
                      message: response.message,
                    });
                    this.handleErrorMessage(response.description);
                    this.error = true;
                    return;
                  }

                  if (!this.error)
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                      source: "product-form",
                      productVariantId: preOrderVariantId,
                    });
                  this.error = false;

                  if (this.miniCart) {
                    this.miniCart.renderContents(response);
                    this.hidePreOrderIdInCart();
                    setTimeout(() => this.hidePreOrderIdInCart(), 500);
                  }
                })
                .catch((e) => {
                  this.handleErrorMessage(
                    `Erro ao adicionar produto: ${e.message}`
                  );
                })
                .finally(() => {
                  preOrderBtnEl.classList.remove("loading");
                  preOrderBtnEl.removeAttribute("aria-disabled");
                });

              return;
            }

            if (this.miniCart) {
              formData.append(
                "sections",
                this.miniCart.getSectionsToRender().map((section) => section.id)
              );
            }
            formData.append("sections_url", window.location.pathname);
            config.body = formData;

            fetch(`${theme.routes.cart_add_url}`, config)
              .then((response) => {
                if (!response.ok) {
                  return response.text().then((text) => {
                    throw new Error(`HTTP ${response.status}: ${text}`);
                  });
                }

                return response.json();
              })
              .then((response) => {
                if (response.status) {
                  publish(PUB_SUB_EVENTS.cartError, {
                    source: "product-form",
                    productVariantId: formData.get("id"),
                    errors: response.errors || response.description,
                    message: response.message,
                  });
                  this.handleErrorMessage(response.description);
                  this.error = true;
                  return;
                }

                if (!this.error)
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: "product-form",
                    productVariantId: formData.get("id"),
                  });
                this.error = false;

                if (this.miniCart) {
                  this.miniCart.renderContents(response);
                  this.hidePreOrderIdInCart();
                  setTimeout(() => this.hidePreOrderIdInCart(), 500);
                }
              })
              .catch((e) => {
                this.handleErrorMessage(
                  `Erro ao adicionar produto: ${e.message}`
                );
              })
              .finally(() => {
                preOrderBtnEl.classList.remove("loading");
                preOrderBtnEl.removeAttribute("aria-disabled");
              });
          });
        });
      }

      hidePreOrderIdInCart() {
        const productOptions = document.querySelectorAll(".product-option");

        productOptions.forEach((option) => {
          const dtElement = option.querySelector("dt");
          const ddElement = option.querySelector("dd");

          if (dtElement && ddElement) {
            const dtText = dtElement.textContent.trim();
            const ddText = ddElement.textContent.trim();

            if (dtText === "id:" || dtText === "ID:") {
              option.style.display = "none";
            }
          }
        });
      }

      setupCartIdObserver() {
        const cartIdObserver = new MutationObserver((mutations) => {
          let shouldHideIds = false;

          mutations.forEach((mutation) => {
            if (
              mutation.type === "childList" &&
              mutation.addedNodes.length > 0
            ) {
              mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1) {
                  if (
                    node.classList?.contains("cart-item") ||
                    node.querySelector?.(".cart-item") ||
                    node.classList?.contains("product-option")
                  ) {
                    shouldHideIds = true;
                  }
                }
              });
            }
          });

          if (shouldHideIds) {
            this.hidePreOrderIdInCart();
          }
        });

        const setupObservers = () => {
          const cartContainers = [
            document.querySelector(".cart__items"),
            document.querySelector(".cart-drawer__contents"),
            document.querySelector(".cart-page"),
            document.querySelector(".cart"),
            document.querySelector(".cart-drawer"),
            document.querySelector("[data-cart-drawer]"),
          ].filter(Boolean);

          cartContainers.forEach((container) => {
            cartIdObserver.observe(container, {
              childList: true,
              subtree: true,
              attributes: false,
            });
          });
        };

        setupObservers();

        let currentUrl = window.location.href;
        setInterval(() => {
          if (window.location.href !== currentUrl) {
            currentUrl = window.location.href;
            setupObservers();
            this.hidePreOrderIdInCart();
          }
        }, 1000);

        setTimeout(() => {
          this.hidePreOrderIdInCart();
        }, 100);

        setTimeout(() => {
          this.hidePreOrderIdInCart();
        }, 500);

        setTimeout(() => {
          this.hidePreOrderIdInCart();
        }, 1000);

        setInterval(() => {
          this.hidePreOrderIdInCart();
        }, 2000);

        document.addEventListener("visibilitychange", () => {
          if (!document.hidden) {
            this.hidePreOrderIdInCart();
          }
        });

        document.addEventListener("cart:opened", () => {
          setTimeout(() => {
            this.hidePreOrderIdInCart();
          }, 100);
        });

        document.addEventListener("cart:updated", () => {
          setTimeout(() => {
            this.hidePreOrderIdInCart();
          }, 100);
        });
      }

      setupCartObserver() {
        const cartObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (
              mutation.type === "childList" &&
              mutation.addedNodes.length > 0
            ) {
              mutation.addedNodes.forEach((node) => {
                if (
                  node.nodeType === 1 &&
                  node.classList?.contains("cart-item__details")
                ) {
                  setTimeout(() => this.hidePreOrderIdInCart(), 50);
                }
              });
            }
          });
        });

        const cartContainer =
          document.querySelector(".cart-drawer__contents") ||
          document.querySelector(".cart__items");
        if (cartContainer) {
          cartObserver.observe(cartContainer, {
            childList: true,
            subtree: true,
          });
        }
      }
    }
  );
}

class CartDrawerPreorderBanner extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.updateCountdown();
    setInterval(this.updateCountdown, 3600000);
  }

  updateCountdown() {
    const daysElement = document.getElementById("cart-drawer-days-count");
    if (daysElement) {
      const endDate = new Date("2025-07-01T00:00:00");
      const today = new Date();
      const timeDiff = endDate - today;

      if (timeDiff > 0) {
        const daysLeft = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
        daysElement.textContent = daysLeft;
      } else {
        daysElement.textContent = "0";
      }
    }
  }
}

customElements.define("cart-drawer-preorder-banner", CartDrawerPreorderBanner);

(function () {
  function hideChatWhenCartOpen() {
    const chatElement = document.querySelector('inbox-online-store-chat');
    if (chatElement) {
      const isCartOpen = document.body.classList.contains('mini-cart--open') ||
        document.body.classList.contains('mini-cart--opening') ||
        document.body.classList.contains('mini-cart--closing');

      const isDistributorPage = window.location.pathname.includes('/pages/distributor-page');

      if (isCartOpen || isDistributorPage) {
        chatElement.style.display = 'none';
        chatElement.style.visibility = 'hidden';
        chatElement.style.opacity = '0';
        chatElement.style.pointerEvents = 'none';
      } else {
        chatElement.style.display = '';
        chatElement.style.visibility = '';
        chatElement.style.opacity = '';
        chatElement.style.pointerEvents = '';
      }
    }
  }

  const bodyObserver = new MutationObserver(hideChatWhenCartOpen);
  bodyObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });

  const chatObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 && node.tagName === 'INBOX-ONLINE-STORE-CHAT') {
          hideChatWhenCartOpen();
        }
      });
    });
  });

  chatObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  hideChatWhenCartOpen();

  setTimeout(hideChatWhenCartOpen, 1000);
  setTimeout(hideChatWhenCartOpen, 3000);
})();

// Hide Klaviyo teaser when cart is open
(function () {
  function hideKlaviyoTeaserWhenCartOpen() {
    // Try multiple selectors to catch the Klaviyo teaser
    const selectors = [
      '[class*="kl-teaser-"]',
      '.kl-teaser-TnAuV5',
      '[class*="klaviyo"]',
      'div[role="button"][class*="kl-teaser"]'
    ];

    let klaviyoTeasers = [];
    selectors.forEach(function (selector) {
      const elements = document.querySelectorAll(selector);
      elements.forEach(function (el) {
        if (el.classList && el.classList.toString().includes('kl-teaser')) {
          klaviyoTeasers.push(el);
        }
      });
    });

    // Remove duplicates
    klaviyoTeasers = Array.from(new Set(klaviyoTeasers));

    if (klaviyoTeasers.length > 0) {
      const isCartOpen = document.body.classList.contains('mini-cart--open') ||
        document.body.classList.contains('mini-cart--opening') ||
        document.body.classList.contains('mini-cart--closing');

      klaviyoTeasers.forEach(function (teaser) {
        if (isCartOpen) {
          teaser.style.setProperty('display', 'none', 'important');
        } else {
          teaser.style.removeProperty('display');
        }
      });
    }
  }

  const bodyObserver = new MutationObserver(hideKlaviyoTeaserWhenCartOpen);
  bodyObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });

  const klaviyoObserver = new MutationObserver(function (mutations) {
    let shouldUpdate = false;
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          // Check if node itself or any child has kl-teaser class
          if ((node.classList && node.classList.toString().includes('kl-teaser')) ||
            (node.querySelector && node.querySelector('[class*="kl-teaser"]'))) {
            shouldUpdate = true;
          }
        }
      });
    });
    if (shouldUpdate) {
      hideKlaviyoTeaserWhenCartOpen();
    }
  });

  klaviyoObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  hideKlaviyoTeaserWhenCartOpen();

  setTimeout(hideKlaviyoTeaserWhenCartOpen, 500);
  setTimeout(hideKlaviyoTeaserWhenCartOpen, 1000);
  setTimeout(hideKlaviyoTeaserWhenCartOpen, 2000);
  setTimeout(hideKlaviyoTeaserWhenCartOpen, 3000);
  setTimeout(hideKlaviyoTeaserWhenCartOpen, 5000);
})();

(function () {
  document.addEventListener('click', function (e) {
    const target = e.target;

    const closeButton = target.closest('.klaviyo-close-form, button[aria-label*="Close"]');
    const noThanksButton = target.closest('button');

    const isOverlayClick = target.getAttribute('role') === 'dialog' && target.getAttribute('aria-label') && target.getAttribute('aria-label').includes('POPUP');

    if (closeButton || (noThanksButton && noThanksButton.textContent.includes('No, Thank you')) || isOverlayClick) {
      const popupDialog = document.querySelector('div[role="dialog"][aria-label*="POPUP"]');

      if (popupDialog) {
        const otherModals = document.querySelector('modal-dialog[open], .promo-popup.is-active, .l-hulk-form-popup.is-active');
        if (!otherModals) {
          document.body.classList.remove('overflow-hidden');
          document.body.classList.remove('klaviyo-prevent-body-scrolling');
          document.documentElement.classList.remove('overflow-hidden');

          document.body.style.removeProperty('overflow');
          document.body.style.removeProperty('position');
          document.body.style.removeProperty('width');
          document.body.style.removeProperty('height');
          document.body.style.removeProperty('touch-action');
          document.body.style.removeProperty('pointer-events');
          document.body.style.removeProperty('top');
          document.body.style.removeProperty('left');

          document.documentElement.style.removeProperty('overflow');
          document.documentElement.style.removeProperty('position');
          document.documentElement.style.removeProperty('touch-action');
          document.documentElement.style.removeProperty('height');

          document.body.setAttribute('style', (document.body.getAttribute('style') || '') + ' overflow: visible !important;');

          setTimeout(function () {
            const currentStyle = document.body.getAttribute('style') || '';
            document.body.setAttribute('style', currentStyle.replace(/overflow\s*:\s*visible\s*!important\s*;?/g, ''));
          }, 500);
        }

        const klaviyoOverlays = document.querySelectorAll('div[style*="position: fixed"][style*="z-index"]');
        klaviyoOverlays.forEach(function (overlay) {
          if (overlay.classList && overlay.classList.toString().includes('klaviyo')) {
            overlay.style.pointerEvents = 'none';
            overlay.style.display = 'none';
          }
        });

        setTimeout(function () {
          if (popupDialog.parentNode) {
            popupDialog.parentNode.remove();
          }

          const klaviyoContainers = document.querySelectorAll('[class*="klaviyo"], [data-testid="POPUP"]');
          klaviyoContainers.forEach(function (container) {
            const style = window.getComputedStyle(container);
            const isHidden = style.display === 'none' ||
              style.visibility === 'hidden' ||
              parseFloat(style.opacity) < 0.1;

            if (isHidden) {
              container.remove();
            }
          });

          const stillHasModals = document.querySelector('modal-dialog[open], .promo-popup.is-active, .l-hulk-form-popup.is-active');
          if (!stillHasModals) {
            document.body.classList.remove('overflow-hidden');
            document.body.classList.remove('klaviyo-prevent-body-scrolling');
            document.documentElement.classList.remove('overflow-hidden');

            const bodyStyles = window.getComputedStyle(document.body);
            if (bodyStyles.overflow === 'hidden') {
              document.body.style.overflow = 'auto';
              setTimeout(function () {
                document.body.style.overflow = '';
              }, 100);
            }

            const htmlStyles = window.getComputedStyle(document.documentElement);
            if (htmlStyles.overflow === 'hidden') {
              document.documentElement.style.overflow = 'auto';
              setTimeout(function () {
                document.documentElement.style.overflow = '';
              }, 100);
            }
          }
        }, 400);
      }
    }
  }, true);
})();
